<template>
  <div>
    <div class="content-header case-search-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input
            :key="'searchtxt'"
            icon-pack="feather"
            icon="icon-search"
            v-model.lazy="searchtxt"
            placeholder="Search by Name/Email"
            class="is-label-placeholder"
          />
        </div>
        <div
          class="con-select selection_search"
          v-if="
            getTenantTypeId != 2 &&
            [1, 2, 12, 48, 50, 51].indexOf(loginRoleId) <= -1
          "
        >
          <multiselect
            v-model="selectedPetitionerforFilter"
            :options="petitionersList"
            :multiple="true"
            :hideSelected="false"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :select-label="'Select Employer'"
            placeholder="Select Employer"
            label="name"
            track-by="name"
            :preselect-first="false"
            :searchable="true"
            @input="set_filter()"
            @search-change="peritioners_search_fun"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Employer(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
          </multiselect>
        </div>
         <!-- <div class="con-select selection_search">
          <multiselect
            v-model="isActiveListSelected"
            :options="filters_list"
            :multiple="false"
            :hideSelected="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :select-label="'Select Status'"
            placeholder="Select Status"
            label="name"
            track-by="name"
            :preselect-first="false"
            :searchable="true"
            @input="getActiveList"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} status selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
          </multiselect>
        </div> -->
   
        <template v-if="[48,50].indexOf(this.getUserRoleId)>-1">
          <vs-dropdown class="msg_dropdown_icon ml-1" :vs-trigger-click="true">
            <a class="a-icon h-12 w-12" href.prevent >
              <img src="@/assets/images/icons/settings/settings.svg" alt="Gear Icon">
            </a>
            <vs-dropdown-menu class="loginx msg_dropdown">
              <div class="p-2">
                <vs-checkbox :disabled="false" @input="enableCol('Middle Name')"  :name="'selecteAll'"  v-model="isMidNameSelected" class="">Middle Name</vs-checkbox>
              </div>
              <div class="p-2">
                <vs-checkbox :disabled="false"  @input="enableCol('Email')" :name="'selecteAll'"  v-model="isEmailSelected" class="">Email</vs-checkbox>
              </div>
              <div class="p-2">
                <vs-checkbox :disabled="false" @input="enableCol('TD')"  :name="'selecteAll'"  v-model="isTdSelected" class="">Termination Date</vs-checkbox>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
           
          <!-- <vs-checkbox :disabled="false" @input="getActiveList()"  :name="'active'"  v-model="isActiveListSelected" class="">Active</vs-checkbox> -->
          <!-- <vs-checkbox :disabled="false" @input="enableCol('Middle Name')"  :name="'selecteAll'"  v-model="isMidNameSelected" class="">Middle Name</vs-checkbox>
          <vs-checkbox :disabled="false"  @input="enableCol('Email')" :name="'selecteAll'"  v-model="isEmailSelected" class="">Email</vs-checkbox>
          <vs-checkbox :disabled="false" @input="enableCol('TD')"  :name="'selecteAll'"  v-model="isTdSelected" class="">Termination Date</vs-checkbox> -->
          </template>
      </div>
      <!-- getTenantTypeId!=2 &&  v-if="checkBeneficaryInvitePermisions" -->

      <div class="content-header-right">
        <button
          v-if="getUserRoleId !== 12"
          color="primary"
          type="border"
          class="btn light_blue_btn ml-4"
          @click="
            addNewBeneficiary();
            selectedIten = null;
            selectedPetitioner = null;
            inviteBeneficiary = false;
            editMode = false;
          "
        >
          Invite Employee
          <span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </button>
        <vs-inv-dropdown>
          <!-- <vs-dropdown vs-custom-content vs-trigger-click>
          <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
            icon-after>
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content"> -->
            
          <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Employee Status</label>
                    <multiselect
                      v-model="selected_statusids"
                      :options="all_statusids"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :select-label="''"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                      @input="selectedVal"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <div
                    class="vx-col md:w-1/3 w-full con-select"
                    v-if="[1, 2, 12, 48, 50, 51].indexOf(loginRoleId) <= -1"
                  >
                    <label class="typo__label">Select Employer</label>
                    <multiselect
                      v-model="selectedPetitionerforFilter"
                      :options="petitionersList"
                      :multiple="true"
                      :hideSelected="false"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :select-label="'Search Employer'"
                      placeholder="Select Employer"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                      :searchable="true"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Employer(s) selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Hire Date</label>
                    <!-- :maxDate="new Date()" -->
                    <date-range-picker
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_hireDateRange"
                    ></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Termination Date</label>
                     <!-- :maxDate="new Date()" -->
                       <!-- :disabled="false" -->
                    <date-range-picker
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_terminationdate"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <button
                  color="success"
                  class="btn light_blue_btn"
                  type="filled"
                  v-on:click="showFilterCount=true;set_filter()"
                >
                  Apply
                </button>
                <button
                  color="dark"
                  class="btn gray_btn mr-3"
                  type="filled"
                  v-on:click="clear_filter($event)"
                >
                  Clear
                </button>
              </div>

            </div>

          </div>
          <!-- </vs-dropdown-menu> -->
          <!-- </vs-dropdown> -->
        </vs-inv-dropdown>

        <vs-checkbox :disabled="false" @input="selectInvalidate()"  :name="'selecteAll'"  v-model="showInvalidated" class="">Show invalidated</vs-checkbox>
        
      </div>
    </div>

    <NoDataFound
      ref="NoDataFoundRef"
      :loading="isListloading"
      v-if="users.length == 0"
      :content="
        callFromSerch
          ? ''
          : 'You haven\'t created any Employees. Create the Employees to start'
      "
      :heading="isInvalidateSelected ?'No invalidated records' :'No employees found. Try a different search or filter.'"
      type="Employees"
    />
    <div class="accordian-table paf_table" v-if="users.length > 0">
      <vs-table :data="users" :no-data-text="'No data found...!'">
        <template slot="thead">
          <vs-th>
            <a
              @click="sortMe('lastName')"
              v-bind:class="{
                sort_ascending: sortKeys['lastName'] == 1,
                sort_descending: sortKeys['lastName'] != 1,
              }"
            >
              Last Name
            </a>
          </vs-th>
          <vs-th>
            <a
              @click="sortMe('firstName')"
              v-bind:class="{
                sort_ascending: sortKeys['firstName'] == 1,
                sort_descending: sortKeys['firstName'] != 1,
              }"
            >
              First Name
            </a>
          </vs-th>
          <vs-th v-if="isMidNameSelected">
            <a
              @click="sortMe('middleName')"
              v-bind:class="{
                sort_ascending: sortKeys['middleName'] == 1,
                sort_descending: sortKeys['middleName'] != 1,
              }"
            >
              Middle Name
            </a>
          </vs-th>
           <vs-th v-if="isEmailSelected">
            <a
              @click="sortMe('email')"
              v-bind:class="{
                sort_ascending: sortKeys['email'] == 1,
                sort_descending: sortKeys['email'] != 1,
              }"
            >
              Email
            </a>
          </vs-th>
       <vs-th>
            <a
              @click="sortMe('hiredOn')"
              v-bind:class="{
                sort_ascending: sortKeys['hiredOn'] == 1,
                sort_descending: sortKeys['hiredOn'] != 1,
              }"
            >
              Hire Date
            </a>
          </vs-th>
           <vs-th>
            <a
              @click="sortMe('statusName')"
              v-bind:class="{
                sort_ascending: sortKeys['statusName'] == 1,
                sort_descending: sortKeys['statusName'] != 1,
              }"
            >
             Employee Status
            </a>
          </vs-th>
          <vs-th v-if="isTdSelected">
            <a
              @click="sortMe('terminatedOn')"
              v-bind:class="{
                sort_ascending: sortKeys['terminatedOn'] == 1,
                sort_descending: sortKeys['terminatedOn'] != 1,
              }"
            >
              Termination Date
            </a>
          </vs-th>
          <!-- <vs-th>
            <a @click="sortMe('statusName')"
              v-bind:class="{'sort_ascending':sortKeys['statusName']==1, 'sort_descending':sortKeys['statusName']!=1}">

              Status
            </a>
          </vs-th> -->

          <vs-th class="actions">Actions </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.lastName">
              <span>
                {{ tr.lastName }}
              </span>
            </vs-td>
            <vs-td :data="tr.firstName">
              <span>
                {{ tr.firstName }}
              </span>
            </vs-td>
            <vs-td :data="tr.middleName" v-if="isMidNameSelected">
              <span>
                {{ tr.middleName}}
              </span>
            </vs-td>
            <vs-td :data="tr.email" v-if="isEmailSelected">
              <span>
                {{ tr.email}}
              </span>
            </vs-td>
            <!-- {{tr}} -->
            <vs-td>
              <span v-if="tr.hiredOn">{{ tr.hiredOn | formatDate }}</span>
              <span v-else>{{ "-" }}</span>
            </vs-td>
            <vs-td :data="tr.statusDetails">
              <div>
                <span
                  class="statusspan pointer"
                  :class="{
                    status_pending:
                      checkProperty(tr, 'statusDetails', 'id') == 1,
                    status_active:
                      checkProperty(tr, 'statusDetails', 'id') == 2,
                    status_onHold:
                      checkProperty(tr, 'statusDetails', 'id') == 3,
                    status_rejected:
                      [4, 5].indexOf(checkProperty(tr, 'statusDetails', 'id')) >
                      -1,
                  }"
                  >{{ checkProperty(tr, "statusDetails", "name") }}</span
                >
              </div>
            </vs-td>
            <vs-td v-if="isTdSelected">
              <span v-if="tr.terminatedOn">{{
                tr.terminatedOn | formatDate
              }}</span>
              <span v-else>{{ "-" }}</span>
            </vs-td>
            <!-- <vs-td :data="tr.createdOn">
              <span >{{ tr.createdOn | formatDate }}</span>
            </vs-td> -->
            <!-- <vs-td :data="tr.statusDetails">
              <div>
                <span class="statusspan pointer"
                :class="
                {'status_pending':checkProperty( tr,'statusDetails','id' )==1,'status_active':checkProperty( tr,'statusDetails','id' ) ==2,'status_onHold':checkProperty( tr,'statusDetails','id' )==3,'status_rejected':[4,5].indexOf(checkProperty( tr,'statusDetails','id' )) > -1}">{{checkProperty(tr
                ,"statusDetails" ,'name')}}</span> -->
            <!-- <span class="user_role pl-6" v-if=" checkProperty( tr,'petitionerUserDetails','statusId' ) ==4" >deleted</span>
                <span class="user_role" v-if="tr.registrationCompleted==true">(Profile Completed)</span> -->
            <!-- </div>
              
            </vs-td> -->
            <vs-td>
              <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                <a class="a-icon" href.prevent>
                  <more-vertical-icon
                    size="1.5x"
                    class="custom-class cursor"
                  ></more-vertical-icon>
                </a>
                <!-- v-if="showDropdownIcon(tr)" -->
                <vs-dropdown-menu class="loginx msg_dropdown">
                  <template>
                    <vs-dropdown-item>
                      <a>
                        <p
                          style="cursor: pionter"
                          @click="
                            userDetails = tr;
                            showDetails(tr);
                          "
                        >
                          Details
                        </p>
                      </a>
                    </vs-dropdown-item>
                    <!-- <vs-dropdown-item  
                      v-if="[3,4,5,7,50].indexOf(loginRoleId)>-1 && tr.statusId !=3 && tr.statusId !=4 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                      @click="editMode = false;showSetPassword(true ,tr);formerrors.msg='';NewPetition=false"><span>Set Password</span> 
                    </vs-dropdown-item> -->
                     <vs-dropdown-item
                      v-if="
                        [3, 4, 5, 7,48, 50].indexOf(loginRoleId) > -1 &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false &&
                        [4,5].indexOf(checkProperty(tr, 'statusId')) <= -1
                      "
                      @click="editEmployee(tr)"
                      ><span>Edit</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      :disabled="countdowns[checkProperty(tr, 'email')] > 0"
                      v-if="
                        [3, 4, 5, 7,48, 50].indexOf(loginRoleId) > -1 &&
                        // checkProperty(tr, 'statusDetails', 'id') <= 1 &&
                        // tr.statusId != 3 &&
                        // tr.statusId != 4 && 
                        !checkProperty(tr, 'passwordUpdated') &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false &&
                        [4,5].indexOf(checkProperty(tr, 'statusId')) <= -1
                      "
                      @click="
                        editMode = false;
                        resend(tr);
                        formerrors.msg = '';
                        NewPetition = false;
                      "
                      ><span v-if="countdowns[checkProperty(tr, 'email')] > 0">Resend Activation Link in {{ countdowns[checkProperty(tr, 'email')] }}s</span>
                      <span v-else>Resend Activation Link</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="
                        [3, 48, 50].indexOf(loginRoleId) > -1 &&
                        ([5].includes(tr.statusId) || checkProperty(tr, 'terminatedOn')) &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false
                      "
                      @click="
                        editMode = false;
                        errorMsg = '';
                        NewPetition = false;
                        terminateEmp(tr, true);
                      "
                      ><span>Edit Termination</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="
                        [3, 48, 50].indexOf(loginRoleId) > -1 &&
                        ([5].includes(tr.statusId) || tr.terminatedOn) &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false
                      "
                      @click="
                        editMode = false;
                        userIdForUndoTermination = tr._id;
                        showUndoTerminationConfirmPopup = true;
                        errorMsg = '';
                        NewPetition = false;
                      "
                      ><span>Undo Termination</span>
                    </vs-dropdown-item>
                    <vs-divider color="dark" class=" px-2 my-2" v-if="loginRoleId !== 12 && isItrequiredToshow(tr)" />
                   <!-- <vs-dropdown-item v-if="loginRoleId !== 12 && isItrequiredToshow(tr)">
                      <span>_______________________</span>
                    </vs-dropdown-item> -->
                    <!-- <vs-dropdown-item
                      v-if="
                        [3,48, 50].indexOf(loginRoleId) > -1 &&
                        tr.statusId == 3 &&
                        tr.statusId != 2 &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false
                      "
                      @click="
                        editMode = false;
                        conformDeleteBene(tr, 2);
                        errorMsg = '';
                        NewPetition = false;
                      "
                      ><span>Active</span>
                    </vs-dropdown-item> -->
                      <vs-dropdown-item
                      v-if="
                        [3,48,50].indexOf(loginRoleId) > -1 &&
                        checkProperty(tr, 'statusDetails', 'id') == 4 &&
                        checkProperty(tr, 'statusDetails', 'name') == 'Invalidated'
                      "
                      @click="
                        editMode = false;
                        userIdForRestore = tr._id;
                        showRestoreConfirmationPopup = true;
                        errorMsg = '';
                        NewPetition = false;
                      "
                      ><span>Restore</span>
                    </vs-dropdown-item>
                    <!-- <vs-dropdown-item  
                      v-if="[3,50].indexOf(loginRoleId) > -1 && tr.statusId==2 && tr.statusId !=3 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                            @click="editMode = false;conformDeleteBene(tr ,3);errorMsg='';NewPetition=false"><span>Inactive</span> 
                    </vs-dropdown-item> -->
                     <vs-dropdown-item
                      v-if="
                        [3,48, 50].indexOf(loginRoleId) > -1 &&
                        [2].includes(tr.statusId) &&
                        tr.hiredOn && 
                        isTodayOrBefore(tr.hiredOn) &&
                        !tr.terminatedOn
                      "
                      @click="
                        editMode = false;
                        errorMsg = '';
                        NewPetition = false;
                        terminateEmp(tr);
                      "
                      ><span>Terminate</span>
                    </vs-dropdown-item>
                      
                    <vs-dropdown-item
                      v-if="
                        [3,48, 50].indexOf(loginRoleId) > -1 &&
                        tr.statusId != 4 &&
                        !tr.isTempAccount &&
                        checkProperty(tr, 'deleteMyProfile') == false
                      "
                      @click="
                        editMode = false;
                        conformDeleteBene(tr, 4);
                        errorMsg = '';
                        NewPetition = false;
                      "
                      ><span style="color: red;">Invalidate </span>
                    </vs-dropdown-item>
                   
                    <!-- Active Button for Terminated employees -->
                     
                  </template>
                </vs-dropdown-menu>
              </vs-dropdown>

              <!-- <div class="menu_dropdown flexible_actions">
                <a class="a-icon" href.prevent>
                    <more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon>
                </a>
                <div class="menu_list_wrap">
                    <ul class="menu_list">
                        <li class="menu_item" v-if="[3,4,5,7].indexOf(loginRoleId)>-1 && tr.statusId !=3 && tr.statusId !=4 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                            @click="editMode = false;showSetPassword(true ,tr);formerrors.msg='';NewPetition=false">
                            Set Password
                        </li>
                        <li class="menu_item"
                            v-if="[3,4,5,7,50].indexOf(loginRoleId)>-1 && checkProperty(tr ,'statusDetails','id') <=1 && tr.statusId !=3 && tr.statusId !=4 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                            @click="editMode = false;resend(tr);formerrors.msg='';NewPetition=false">
                            Resend Activation Link
                        </li>
                        <li class="menu_item"
                            v-if="[3].indexOf(loginRoleId) > -1 && tr.statusId==3 && tr.statusId !=2 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                            @click="editMode = false;conformDeleteBene(tr ,2);errorMsg='';NewPetition=false">
                            Active
                        </li>
                        <li class="menu_item"
                            v-if="[3].indexOf(loginRoleId) > -1 && tr.statusId==2 && tr.statusId !=3 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false"
                            @click="editMode = false;conformDeleteBene(tr ,3);errorMsg='';NewPetition=false">
                            Inactive
                        </li>
                        <li class="menu_item"
                            v-if="[3].indexOf(loginRoleId) > -1 && tr.statusId !=4 && !tr.isTempAccount&& checkProperty(tr, 'deleteMyProfile') ==false "
                            @click="editMode = false;conformDeleteBene(tr ,4);errorMsg='';NewPetition=false">
                            Delete 
                        </li>
                    </ul>
                </div> 
                </div> -->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col con-select pages_select" v-if="users.length > 0">
          <label class="typo__label">Per Page</label>
          <multiselect
            @input="changeperPage()"
            v-model="perpage"
            :options="perPeges"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Per Page"
            :preselect-first="true"
          >
          </multiselect>
          <span class="totla_list_count" v-if="totalCount">
            Total <em>{{ totalCount }}</em></span
          >
        </div>
        <paginate
          v-if="users.length > 0"
          v-model="page"
          :page-count="totalpages"
          :page-range="3"
          :margin-pages="2"
          :click-handler="pageNate"
          prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
          :prev-text="'<i></i>'"
          :next-text="'<i></i>'"
          :container-class="'pagination vs-pagination--nav'"
          :page-class="'page-item'"
        ></paginate>
      </div>
    </div>
    <vs-popup
      class="holamundo main-popup index-lg"
      title="Invite Employer"
      :active.sync="invitepetitioner"
    >
      <addBenewPet
        @closenewPetPopup="closenewPetPopup"
        v-if="invitepetitioner"
      />
    </vs-popup>

    <vs-popup v-if="false"
      class="holamundo main-popup"
      :class="{ 'openedNewpetpopup': invitepetitioner }"
      :title="
        editMode
          ? 'Edit Employee'
          : inviteBeneficiary
          ? 'Invite Employee'
          : 'Add Employee'
      "
      :active.sync="AddBeneficiary"
    >
      <addNewbeneficiary
        ref="add_ben"
        @closeAddBenPopUp="closeAddBenPopUp"
        v-if="AddBeneficiary"
        :selectedItem="selectedIten"
        :petitioner="selectedPetitioner"
        @openAddpetPopUp="openAddpetPopUp"
        :beneDetails="userDetails"
        :callFromList="true"
        :editMode="editMode"
        :activeI9CaseId="i9CaseId"
        @openEditTerminate="openEditTerminate"
      />
    </vs-popup>

    <div :class="{ 'openedNewpetpopup': invitepetitioner }" v-if="AddBeneficiary"> 
      <addNewbeneficiary
        ref="add_ben"
        @closeAddBenPopUp="closeAddBenPopUp"
        v-if="AddBeneficiary"
        :selectedItem="selectedIten"
        :petitioner="selectedPetitioner"
        @openAddpetPopUp="openAddpetPopUp"
        :beneDetails="userDetails"
        :callFromList="true"
        :editMode="editMode"
        :activeI9CaseId="i9CaseId"
        @openEditTerminate="openEditTerminate"
      />
    </div>
    

    <vs-popup
      class="holamundo main-popup"
      title="Set Password"
      :active.sync="setPassword"
    >
      <form @submit.prevent>
        <div class="popup-accounts-content edit_password" v-if="setPassword">
          <div class="form-container" @click="setPasswordErrorMsg = ''">
            <div class="form_group">
              <!-- <i class="placeholder-icon IP-hide-1"></i> -->
              <label class="form_label">New Password<em>*</em></label>
              <vs-input
                :key="'currentPassword'"
                type="password"
                v-validate="'required|min:6|max:15|strongpassword'"
                data-vv-as="New Password"
                name="currentPassword"
                v-model="newPassword"
                class="w-full no-icon-border"
                ref="password"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('currentPassword')"
                >{{ errors.first("currentPassword") }}<br
              /></span>
            </div>
            <div class="form_group">
              <!-- <i class="placeholder-icon IP-hide-1"></i> -->
              <label class="form_label">Confirm Password<em>*</em></label>
              <vs-input
                :key="'newPassword'"
                type="password"
                v-validate="'required|confirmed:password'"
                data-vv-as="Confirm Password"
                v-model="confPassword"
                name="newPassword"
                class="w-full no-icon-border"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('newPassword')"
                >{{ errors.first("newPassword") }}</span
              >
            </div>

            <div v-if="setPasswordErrorMsg">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
                >{{ setPasswordErrorMsg }}</vs-alert
              >
            </div>
          </div>
          <div class="popup-footer justify-between relative">
            <div class="password-count">
              <i class="icon IP-lock"></i> Password must contain 6 to 15
              characters
            </div>

            <div class="d-flex">
              <button
                color="dark"
                @click="
                  setPassword = false;
                  updatingPassword = false;
                "
                class="btn gray_btn mr-3"
                type="filled"
              >
                Cancel
              </button>

              <button
                class="btn light_blue_btn w-auto"
                type="filled"
                @click="changePassword"
                :disabled="updatingPassword"
              >
                <figure v-if="updatingPassword" class="loader">
                  <img src="@/assets/images/main/loader.gif" />
                </figure>
                <template
                  v-if="checkProperty(selectedIten, 'statusDetails', 'id') == 1"
                >
                  Set Password
                </template>
                <template v-else>Update</template>
              </button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup class="holamundo main-popup" :title="'Restore Employee Record'" v-if="showRestoreConfirmationPopup"   :active.sync="showRestoreConfirmationPopup" >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>You are about to restore this employee record. The employee will return to the appropriate status based on the existing record information. Do you want to continue?</p>
          </div>
        </div>
      </div>
      <div class="popup-footer relative">
        <figure v-if="loading" class="loader">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
        <vs-button color="dark" class="cancel" type="filled" @click="showRestoreConfirmationPopup=false">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled"  v-on:click="reinstateTerminatedEmp(userIdForRestore, 'restore')">Confirm Restore</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="holamundo main-popup" :title="'Undo Termination'" v-if="showUndoTerminationConfirmPopup"   :active.sync="showUndoTerminationConfirmPopup" >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>Are you sure you want to undo this employee's termination?</p>
          </div>
        </div>
      </div>
      <div class="popup-footer relative">
        <figure v-if="loading" class="loader">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
        <vs-button color="dark" class="cancel" type="filled" @click="showUndoTerminationConfirmPopup=false">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled"  v-on:click="reinstateTerminatedEmp(userIdForUndoTermination, 'undoTermination')">Confirm</vs-button>
      </div>
    </vs-popup>

    <RevertAction
      v-if="showRevertPopup"
      @handleCloseRevertPopup="handleCloseRevertPopup"
      :userData="userData"
    />
    <vs-popup
      class="holamundo main-popup"
      :title="popUpTitle"
      :active.sync="deleteBeneficiaryPopup"
      @close="selectedReason=null"
    >
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <!------  this.popUpText  =callFrom; active inactive delete-->

            <!-- <p>{{ popUpText }} </p> -->
            <p v-if="selectedStatus != 4">Are you sure to continue?</p>
            <template v-else>
              <!-- <form @submit.prevent="" @keydown.enter.prevent=""> -->
               <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                    >{{ 'You are about to invalidate this employee record. This hides it from standard views but retains it for audit purposes. Please select a reason' }}</vs-alert
                  >
              <div class="con-select selection_search casetype">
                 <label for="" class="form_label">Select Reason<em>*</em></label>
                <multiselect v-model="selectedReason" :options="reasons_list" :multiple="false"  v-validate="'required'"
                  :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Reason"
                  label="name" track-by="name" :preselect-first="false"   name="reason"  data-vv-as="Reason" @input="reasonText=''">

                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Select Reason(s)
                      Selected</span>
                    <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                  </template>
                  <!-- <span
                    class="text-danger text-sm"
                    v-show="errors.has('reason')"
                  >{{ errors.first("reason") }}</span> -->
                </multiselect>
                   <span
                    class="text-danger text-sm mt-0"
                    v-show="errors.has('reason')"
                  >{{ errors.first("reason") }}</span>
             </div>
            <div class="vx-col w-full mb-5" v-if="checkProperty(selectedReason, 'id') == 5">
              <label class="form_label">Comments<em>*</em></label>
              <div class="form_group">
                  <ckeditor  data-vv-as="Comment" v-validate="'required'" v-model="reasonText" name="comment"
                  class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

                <span class="text-danger text-sm pb-3" v-show="errors.has('comment')">
                  {{ errors.first("comment") }}</span>
              </div>
            </div>
            <!-- </form> -->
            </template>
          </div>
        </div>
        <div class="text-danger text-sm formerrors" v-show="errorMsg">
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
            >{{ errorMsg }}</vs-alert
          >
        </div>
      </div>
      <div class="popup-footer relative">
        <span class="loader" v-if="loading"
          ><img src="@/assets/images/main/loader.gif"
        /></span>
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          v-on:click.stop.prevent="deleteBeneficiaryPopup = false;selectedReason=null"
          >Cancel</vs-button
        >
        <vs-button
          v-if="selectedStatus == 2"
          color="success"
          class="save"
          :disabled="loading"
          type="filled"
          v-on:click.stop.prevent="deleteBeneficiary(2)"
        >
          Activate
        </vs-button>
        <vs-button
          v-else-if="selectedStatus == 4"
          color="success"
          class="save"
          :disabled="loading"
          type="filled"
          v-on:click.stop.prevent="deleteBeneficiary(4)"
        >
          Invalidate
        </vs-button>
        <vs-button
          v-else-if="selectedStatus == 3"
          color="success"
          class="save"
          :disabled="loading"
          type="filled"
          v-on:click.stop.prevent="deleteBeneficiary(3)"
        >
          Inactivate
        </vs-button>
      </div>
    </vs-popup>
    <modal
      name="userDetailsPopupModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="750px"
      height="auto"
    >
      <div class="v-modal profile_details_modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Employee Details</h2>
          <span
            @click="
              $modal.hide('userDetailsPopupModal');
              userDetails = null;
            "
          >
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <figure class="dp_img">
                  <img
                    class="user-image"
                    :src="
                      checkProperty(userDetails, 'details', 'profilePicture')
                    "
                    @error="setDefaultPhoto($event, '', (type = 'user'))"
                  />
                  <figcaption>
                    {{
                      checkProperty(userDetails, "firstName") +
                      " " +
                      checkProperty(userDetails, "middleName") +
                      " " +
                      checkProperty(userDetails, "lastName")
                    }}
                    <span>{{
                      checkProperty(userDetails, "roleDetails", "name")
                    }}</span>
                  </figcaption>
                  <div class="flex flex-col ml-4 items-start emp-detail-status">
                    <vs-chip v-if="[51].indexOf(getUserRoleId) <= -1" class="self-start"
                      :color="getEmployeeStatusColor(checkProperty(userDetails, 'statusDetails', 'id'))">
                      {{ checkProperty(userDetails, 'statusDetails', 'name') }}
                    </vs-chip>
                    <span v-if="getActivationSubtext(userDetails)" class="text-xs text-gray-600">
                        {{ getActivationSubtext(userDetails) }}
                    </span>
                  </div>
                  <!-- <span v-if="[51].indexOf(getUserRoleId) <= -1" 
                    v-bind:class="['status_block ml-4 self-start',{
                      status_pending: checkProperty(userDetails, 'statusDetails', 'id') == 1,
                      status_active: checkProperty(userDetails, 'statusDetails', 'id') == 2,
                      status_onHold: checkProperty(userDetails, 'statusDetails', 'id') == 3,
                      status_rejected: [4, 5].includes(checkProperty(userDetails, 'statusDetails', 'id'))
                    }]">
                      {{ checkProperty(userDetails, 'statusDetails', 'name') }}
                  </span> -->
                </figure>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'email')"
            >
              <div class="form_group">
                <label class="form_label">Email</label>
                <span>{{ checkProperty(userDetails, "email") }}</span>
              </div>
            </div>
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'hiredOn')"
            >
              <div class="form_group">
                <!-- <label class="form_label">Hired On</label> -->
                 <label class="form_label">Hire Date</label>
                <span>{{ userDetails.hiredOn | formatDate }}</span>
              </div>
            </div>
            
          </div>
          <div
            class="vx-row"
            v-if="
              $options.filters.formatAddressNew(
                checkProperty(userDetails, 'address')
              )
            "
          >
            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Address</label>
                <span>{{
                  checkProperty(userDetails, "address") | formatAddressNew
                }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'phone')"
            >
              <div class="form_group">
                <label class="form_label">Phone</label>
                <span
                  >{{
                    checkProperty(
                      userDetails,
                      "phoneCountryCode",
                      "countryCallingCode"
                    )
                  }}
                  {{ checkProperty(userDetails, "phone") }}</span
                >
              </div>
            </div>
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'homePhone')"
            >
              <div class="form_group">
                <label class="form_label">Mobile Number</label>
                <span
                  >{{
                    checkProperty(
                      userDetails,
                      "homePhoneCountryCode",
                      "countryCallingCode"
                    )
                  }}
                  {{ checkProperty(userDetails, "homePhone") }}</span
                >
              </div>
            </div>
          </div>
          
          <div class="vx-row">
            
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'terminatedOn')"
            >
              <div class="form_group">
                 <label class="form_label">Termination Date</label>
                <span>{{ userDetails.terminatedOn | formatDate }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="checkProperty(userDetails, 'statusId') === 4">
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'statusChangeLogs', 'length') > 0 && checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change')"
            >
              <div class="form_group">
                 <label class="form_label">Invalidation Reason</label>
                <span>{{ checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change') }}</span>
              </div>
            </div>
            <div
              class="vx-col w-1/2"
              v-if="checkProperty(userDetails, 'statusChangeLogs', 'length') > 0 && checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'reason')"
            >
              <div class="form_group">
                 <label class="form_label">Invalidation Comment</label>
                <span v-html="checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'reason')"></span>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full d-flex" v-if="checkProperty(userDetails, 'updatedOn')">
              <p>Updated on&nbsp 
                <div class="form_group"> 
                  <span>{{checkProperty(userDetails, 'updatedOn') | formatDate }}</span>
                </div> 
                  &nbsp
                <div class="form_group" v-if="checkProperty(userDetails, 'updatedByName')"> 
                  by
                  <span>{{checkProperty(userDetails, 'updatedByName') }}</span>
                </div>
              </p>
            </div>
          </div>
        </div>
        <div class="popup-footer relative justify-between items-center">
          <div class="flex items-center">
            <template v-if="[3, 48, 50].indexOf(getUserRoleId) > -1 && !checkProperty(userDetails, 'passwordUpdated') && [4, 5].indexOf(checkProperty(userDetails, 'statusId')) <= -1">
              <p class="flex items-center gap-1"><img src="@/assets/images/icons/info_btn.png" height="15" width="15"/>Account not activated</p>
              <vs-button color="success" class="save" type="filled" @click="resend(userDetails);" :disabled="countdowns[checkProperty(userDetails, 'email')] > 0">
                <span v-if="countdowns[checkProperty(userDetails, 'email')] > 0">Resend activation link in {{ countdowns[checkProperty(userDetails, 'email')] }}s</span>
                <span v-else>Resend activation link</span>
              </vs-button>
            </template>
          </div>
        <vs-button color="success" class="save" type="filled" @click="$modal.hide('userDetailsPopupModal');">Close </vs-button>
      </div>
      </div>
    </modal>

    <vs-popup
      class="holamundo main-popup"
      title="Terminate Employment"
      :active.sync="terminatePopup"
    >
      <form data-vv-scope="terminateEmployee" @submit.prevent>
        <div class="popup-accounts-content edit_password" v-if="terminatePopup">
          <div class="form-container padb0 mb-5">
            <div class="form_group">
              <datepickerField
                wrapclass="md:w-full"
                v-model="terminatedOn"
                :fieldName="'Termination Date'"
                :formscope="'terminateEmployee'"
                label="Termination Date"
                :validationRequired="true"
                :dateEnableFrom="selectedBeneficiaryItem.hiredOn ? new Date(selectedBeneficiaryItem.hiredOn) : null"
                :enableTodayAlso ="true"
              />
              <!-- :dateEnableFrom="new Date(new Date().setDate(new Date().getDate() - 1))" -->
            </div>
          </div>
          <div class="popup-footer relative">
            <div class="d-flex">
              <vs-button
                color="dark"
                @click="closeTerminateEE()"
                class="cancel"
                type="filled"
                >Cancel</vs-button
              >
              <vs-button
                class="save"
                type="filled"
                @click="confirmTerminate()"
                :disabled="terminteEEloading"
              >
                <figure v-if="terminteEEloading" class="loader">
                  <img src="@/assets/images/main/loader.gif" />
                </figure>
                Confirm
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
  
  <script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import addressField from "@/views/forms/fields/address.vue";
import RevertAction from "./common/revertAccountPopup.vue";
import casedocumentslist from "@/views/common/casedocuments.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";

import datepickerField from "@/views/forms/fields/datepicker.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
//import FileUpload from "vue-upload-component/src";
import NoDataFound from "@/views/common/noData.vue";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import * as _ from "lodash";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import addNewbeneficiary from "@/views/common/inviteEmployee.vue";
// import addNewbeneficiary  from "@/views/common/addBeneficiary.vue"
import addBenewPet from "@/views/common/invitePet.vue";
import { MoreVerticalIcon } from "vue-feather-icons";
import Vue from "vue";
Vue.use(CKEditor);
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FileUpload from "@/views/FileUpload.vue";

import JQuery from "jquery";
import inviteSponser from "@/views/common/inviteSponser.vue";

import quillTextEditor from "./forms/fields/quillTextEditor.vue";
export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    vsInvDropdown,
    casedocumentslist,
    addressField,
    immiInput,
    inviteSponser,
    datepickerField,
    selectField,
    RevertAction,
    immiswitchyesno,
    FileUpload,
    addNewbeneficiary,
    addBenewPet,
    NoDataFound,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    DateRangePicker,
    moment,
    PhoneMaskInput,
    MoreVerticalIcon,
    quillTextEditor,
  },
  data: () => ({
    editTermination: false,
    showInvalidated: false,
    userIdForRestore: '',
    showRestoreConfirmationPopup: false,
    userIdForUndoTermination: '',
    showUndoTerminationConfirmPopup: false,
    cleanupInterval: null,
    timers: {},
    emailCounts: {},
    requestLog: [],
    countdowns: {},
    i9CaseId: null,
    showFilterCount:false,
    reasonText:'',
    filters_list:[
      {'id':1,
        'name':'Any'
      },
      {'id':2,
      'name':'Activated'
      },
       {'id':3,
        'name':'Not activated'
      },
      
    ],
    reasons_list:[
      {
        'id':1,
        'name':'Entered in error'
      },
      {
        'id':2,
        'name':'Test record'
      },
      {
        'id':3,
        'name':'Duplicate'
      },
      {
        'id':4,
        'name':'Never joined'
      },
       {
        'id':5,
        'name':'Other'
      },
    ],
    selectedReason:null,
    isActiveListSelected:null,
    isMidNameSelected:false,
    isEmailSelected:false,
    isTdSelected:false,
    userDetails: null,
    petiApprovReqPWDDoc: false,
    userData: null,
    showRevertPopup: false,
    hideBeneforQues: true,
    benficiaryH1BCases: [],
    inviteSponser: false,
    sponsor: "",
    fillTheQuestionnire: "",
    sponsorList: [],
    rfeDocslist: [
      {
        required: true,
        fileUploading: false,
        key: "orgPetition",
        fieldName: "orgPetition",
        label: "Original Petition",
      },
      {
        required: false,
        fileUploading: false,
        key: "petitionerDocs",
        fieldName: "petitionerDocs",
        label: "Petitioner Documents (if any)",
      },
      {
        required: false,
        fileUploading: false,
        key: "beneficiaryDocs",
        fieldName: "beneficiaryDocs",
        label: "Beneficiary Documents",
      },
      {
        required: false,
        fileUploading: false,
        key: "employmentDocs",
        fieldName: "employmentDocs",
        label: "Employment Documents (if any)",
      },
      {
        required: false,
        fileUploading: false,
        key: "other",
        fieldName: "other",
        label: "Others",
      },
    ],
    documentUploading: false,
    rfeData: {
      rfeIssuedDate: null,
      rfeReceivedDate: null,
      rfeCaseUscisDeadlineDate: null,
      uscisReceiptNumber: "",
      rfeInternalCase: "internalCase", //'externalCase',//'internalCase',
      documents: [],
      docs: {
        copyOfRfe: [],
        orgPetition: [],
        petitionerDocs: [],
        employmentDocs: [],
        beneficiaryDocs: [],
        other: [],
      },
      h1bCaseId: null,
    },

    educationTypes: [],
    draftExtractInfo: null,
    skillTextError: false,
    newSkill: "",
    addSkill: true,
    payFrequencyList: ["Hour", "Week", "Month", "Year"],
    masterSocList: [],
    permDocFormatError: "",
    permJobDetails: null,
    permDetails: {
      i140PriorityDate: null,
      permExpiryDate: null,
      minDegreeDetailsOther: null,
      isExpRequired: null,
      noOfExpMonths: "",
      isAltCombOfEduAndExpAccept: null,
      altLevelOfEduDetails: null,
      altLevelOfEduDetailsOther: "",
      altAcceptExpInYears: null,
      isExpInAltOccuAccept: null,
      noOfExpMonthsInAltOccu: null,
      eduHighLevReqJobOppDetails: null,
      eduHighLevReqJobOppDetailsOther: "",
      eduMajorFieldOfStudy: "",
      eduCompleteYear: "",
      eduInstitution: "",

      socCode: "",
      socDetails: null,
      permApplicationNo: "",
      jobTitle: "",
      eduAddress: {
        line1: null,
        line2: null,
        aptType: null,
        locationId: null,
        locationDetails: null,
        stateId: null,
        stateDetails: null,
        countryId: null,
        countryDetails: null,
        zipcode: null,
      },

      minDegreeDetails: null,
      minDegree: null,
      skills: [],
      majorFieldsOfStudy: "",
      expInYears: null,

      workAddresses: [
        {
          line1: null,
          line2: null,
          aptType: null,
          locationId: null,
          locationDetails: null,
          stateId: null,
          stateDetails: null,
          countryId: 231,
          countryDetails: {
            id: 231,
            shortName: "US",
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
          },
          zipcode: null,
        },
      ],

      fullTimePosition: false,

      hoursPerWeek: "",

      wageRate: "",

      payFrequency: "", // Year, Month, Bi-Weekly, Week, Hour

      description: "",

      permanentPosition: false,

      newPosition: false,
    },
    permDocPreFilledKyes: [],

    isLinkPwd: false,
    selectedPwdId: null,
    // actionPopupText:"",
    editor: ClassicEditor,
    editorConfig: {
      toolbar: [
        "bold",
        "italic",
        "|",
        "undo",
        "redo",
        "NumberedList",
        "BulletedList",
      ],
    },
    i140CreationMessage: "",
    classificationpopup: false,
    classificationResultList: [],
    prefilledKyes: [],
    disablePWDstatus: false,
    prefillJobDetailsError: "",
    pwdDocFormatError: "",
    searchText: "",
    jobDetails: {
      wageRate: "",
      socOccuTitle: "",
      preferredSocOccuTitle: "",

      socCode: "",
      jobTitle: "",
      preferredSocCode: "",
      preferredSocCodeDetails: null,
      classification: "",
      description: "",
      skills: [],
      minDegree: "",
      majorFieldsOfStudy: "",
      expInYears: "",
      altJobRequirements: {
        // Are alternate sets of Education, Training, and/or Experience accepted? "Yes", "No"

        areAltSetsOfEducation: "", // { type: String},
        altevelOfEducation: null, //{ type: Schema.Types.ObjectId, default: null  }, //0bjectId
        altevelOfEducationDetails: null,
        usDiplomaOrDegreeAccepted: "", //{type: String},
        majorsOrFieldsOfStudyAccepted: "", //{type: String},
        isAltTrainingForTheJobOpporAccepted: "", //"Yes" Or "No"
        noOfMonthsOfAltTrainingAccepted: null, //{type: String},
        filedsOrNamesOfTrainingAccepted: "", //{ type: String },
        altEmpExpAccepted: "", //"Yes" Or "No"
        noOfMonthsAltEmpExpAccepted: null,
        splSkillOrOtherRequi: "",
        ForeignLanguage: "",
        LicenseCertification: "",
        residencyFellowship: "",
        otherSplSkillsOrRequi: "",
      },
      workAddresses: [
        {
          companyName: "",
          line1: "",
          line2: "",
          aptType: "",
          locationId: "",
          stateId: "",
          countryId: "",
          zipcode: "",
          locationDetails: {
            id: "",
            name: "",
            stateId: "",
            countryId: "",
          },
          stateDetails: {
            id: "",
            name: "",
            shortName: "",
            countryId: "",
          },
          countryDetails: {
            id: 231,
            shortName: "US",
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
          },
          workLocation: true,
        },
      ],
    },
    pwdStatusList: ["Filed", "Certified"],
    pwdResponse: {
      issuedDate: null,
      receivedDate: null,
      dueDate: null,
      description: "",
      documents: [],
      documentType: "",
    },
    pwdStatus: "",

    questionnaireDetails: null,
    pwdDocs: [],
    hasJobDetails: false,
    isPwdFiled: false,
    value: [],
    uploading: false,
    selectedBeneficiaryId: "",
    permDolDocs: [],
    responsePermId: "",
    i140PriorityDate: null,
    permExpiryDate: null,
    Dol140Docs: [],
    Doc140Required: false,
    response140Id: "",
    permDocRequired: false,
    category: "",
    categoryList: [],
    classification: "",
    classificationList: ["EB2", "EB3", "EB3S"],
    inviteBeneficiary: false,
    setPassword: false,
    moveToIndiduals: false,

    updatingInviteAcoount: false,
    inviteEmail: "",
    newPassword: "",
    confPassword: "",
    updatingPassword: false,
    setPasswordErrorMsg: "",
    moveToIndidualsErrorMsg: "",

    approveConformpopUp: false,

    premiumProcessing: false,
    newPetOpenFromben: false,
    enableAddNewBenTag: false,
    invitepetitioner: false,
    openNewbenForm: false,
    selectedBeneficiary: null,
    beneficiaryMasterDataList: [],
    selectedIten: null,

    addNewPete: false,
    isPetitionerPhoneValid: true,
    newPetitioner: {
      firstName: "",
      lastName: "",
      adminFirstName: "",
      adminLastName: "",
      roleId: 50,
      email: "",
      phone: "",
      active: true,
      address: {
        line1: "",
        line2: "",
        locationId: "",
        stateId: "",
        countryId: 231,
        zipcode: "",
      },
    },
    selectedPetitioner: null,
    petitionersList: [],
    selectedPetitionerforFilter: [],
    enableAddNewpet: false,
    isListloading: false,
    sortKeys: {},
    sortKey: {},
    filteredVisaType: null,
    filteredVisaSubTypes: [],
    allsubTyps: [],
    isPhoneValid: true,
    callFromSerch: false,
    newPetitionFormSubmited: false,
    formerrors: {
      msg: "",
    },
    date: null,
    activeVisatypes: [],
    visatype: {
      id: 1,
      name: "H-1B",
    },
    vuePhone: {
      props: {
        translations: {
          phoneNumberLabel: "Phone Number",
        },
      },
    },
    visasubtype: null,
    selectedBranch: null,
    branchList: [],
    disableOffice: false,
    //visasubtype:null,
    selectedUser: null,
    selectedUsername: null,
    selectedUseremail: null,
    beneficiary: {
      name: "",
      email: "",
      phone: "",
      phoneCountryCode: { countryCode: "", countryCallingCode: "" },
    },
    users: [],
    AddBeneficiary: false,
    NewPetition: false,
    visatypes: [],
    visasubtypes: [],
    searchtxt: "",
    query: [],
    country_code: 231,

    all_countries: [],
    selected_country_obj: "",
    filtered_country: "",

    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],

    all_states: [],
    seleted_states: [],
    final_selected_states: [],
    singel_final_selected_state: "",
    // locationIds
    all_locations: [],
    seleted_locations: [],
    final_selected_locations: [],
    //date: "",
    date_range: [],
    page: 1,
    perPeges: [10, 25, 50, 75, 100], // [  {name:10 ,perPage:10} , {name:25 ,perPage:25} ,{name:50 ,perPage:50},{name:100 ,perPage:100}],
    perpage: 50,
    totalCount: 0,
    totalpages: 0,
    selected_createdDateRange: {},
    selected_normcreatedDateRange: {},
    selected_hireDateRange: {},
    selected_terminationdate:{},
    autoApply: "",
    saveBenbtn: false,
    enableSubmitBtn: true,
    deleteBeneficiaryPopup: false,
    selectedBeneficiaryItem: null,
    errorMsg: "",
    popUpText: "",
    popUpTitle: "",
    selectedStatus: null,
    loginUserData: null,
    loginRoleId: null,
    loading: false,
    userDetails: null,
    //petition: [],
    editMode: false,
    debounce: null,
    encodedString: "",
    terminatedOn: "",
    terminteEEloading: false,
    terminatePopup: false,
    isInvalidateSelected:false
  }),
  watch: {
    searchtxt: function (value) {
      this.searchMe();
    },

    // selected_statusids: function (value) {
    //   this.isInvalidateSelected = value.some((el) => el.id === 4);
    //   const isAllSelected = value.find((el) => el.name === "Select All");
    //   if (isAllSelected) {
    //     this.selected_statusids = this.all_statusids.slice(
    //       0,
    //       this.all_statusids.length - 1
    //     );
    //   }
    // },
  },
  methods: {
    getActivationSubtext(userDetails){
      let today = moment(new Date())
      let hireDate = moment(this.checkProperty(userDetails, 'hiredOn'))
      let terminationDate = this.checkProperty(userDetails, 'terminatedOn')
      let statusId = this.checkProperty(userDetails, 'statusId')
      if (statusId === 1 && hireDate.isAfter(today)){
        return `Becomes Active on ${moment.utc(hireDate).format('MMM DD, YYYY')}`;
      }else if(statusId === 2 && terminationDate && moment(terminationDate).isAfter(today)){
        return `Terminates on ${moment.utc(terminationDate).format('MMM DD, YYYY')}`;
      }else if(statusId === 4 && this.checkProperty(userDetails, 'statusChangeLogs', 'length') > 0 && this.checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change')){
        return this.checkProperty(userDetails['statusChangeLogs'][0], 'causeOfChange', 'change')
      }
    },
    getEmployeeStatusColor(statusId) {
      if (statusId == 1) return 'warning';
      if (statusId == 2) return 'success';
      if (statusId == 3) return 'dark';
      if ([4, 5].includes(statusId)) return 'danger';
      return 'primary';
    },
    isTodayOrBefore(date){
      const today = moment(new Date)
      const givendate = moment(date)
      return givendate.isSameOrBefore(givendate)
    },
    openEditTerminate(val) {
      this.terminateEmp(val);
      this.closeAddBenPopUp()
    },

    saveState() {
      localStorage.setItem("resendActivationLinkCounts", JSON.stringify(this.emailCounts));
      localStorage.setItem("resendActivationLinkLog", JSON.stringify(this.requestLog));
    },
    startCountdown(email, seconds = 60) {
      this.$set(this.countdowns, email, seconds);

      const expiry = Date.now() + seconds * 1000;
      localStorage.setItem(
        `resendActivationLinkTimer_${email}`,
        expiry
      );

      if (this.timers[email]) {
        clearInterval(this.timers[email]);
      }

      this.timers[email] = setInterval(() => {
        this.countdowns[email]--;

        if (this.countdowns[email] <= 0) {
          clearInterval(this.timers[email]);
          this.$delete(this.countdowns, email);
          delete this.timers[email];
          localStorage.removeItem(`resendActivationLinkTimer_${email}`);
        }
      }, 1000);
    },
    cleanupOldRequests() {
      const now = Date.now();
      if (this.requestLog.length > 0) {
        const oldest = this.requestLog[0].timestamp;
        if (now - oldest >=24 * 60 * 1000) {
          this.requestLog = [];
          this.emailCounts = {};
          this.countdown = 0;
          localStorage.removeItem("resendActivationLinkTimer");
          localStorage.removeItem("resendActivationLinkLog");
          localStorage.removeItem("resendActivationLinkCounts");
        }
      }
      this.saveState();
    },
  getActiveList(){
      this.getbeneficiaries()
  },
   selectedVal(value) {
      const allClicked = value.some((el) => String(el.id) === "all");
      if (allClicked) {
        const nonAllSelectedCount = value.filter((el) => String(el.id) !== "all").length;
        const totalNonAllCount = this.all_statusids.filter((el) => String(el.id) !== "all").length;

        if (nonAllSelectedCount === totalNonAllCount) {
          this.selected_statusids = [];
        } else {
          this.selected_statusids = this.all_statusids.filter((el) => String(el.id) !== "all");
        }
      }
      this.isInvalidateSelected = this.selected_statusids.some((el) => el.id === 4);
    },


    isItrequiredToshow(tr){
      let isActive = [3,48, 50].indexOf(this.loginRoleId) > -1 && tr.statusId == 3 && tr.statusId != 2 && !tr.isTempAccount && this.checkProperty(tr, 'deleteMyProfile') == false
      let isRestore = [3,48].indexOf(this.loginRoleId) > -1 && this.checkProperty(tr, 'statusDetails', 'id') == 4 && this.checkProperty(tr, 'statusDetails', 'name') == 'Invalidated'
      let isTerminate = [3,48, 50].indexOf(this.loginRoleId) > -1 && [2].includes(tr.statusId)
      let isEditTermination =  [3, 48, 50].indexOf(this.loginRoleId) > -1 && [5].includes(tr.statusId) && !tr.isTempAccount && this.checkProperty(tr, 'deleteMyProfile') == false
      let undoTermination = [3, 48, 50].indexOf(this.loginRoleId) > -1 &&[5].includes(tr.statusId) &&!tr.isTempAccount && this.checkProperty(tr, 'deleteMyProfile') == false
      let isInvalidate = [3,48, 50].indexOf(this.loginRoleId) > -1 && tr.statusId != 4 && !tr.isTempAccount && this.checkProperty(tr, 'deleteMyProfile') == false
      return isActive || isRestore || isTerminate || isEditTermination || undoTermination  || isInvalidate
      
    },
    selectInvalidate() {
      this.getbeneficiaries()
        // let invalidate = {
        //   "_id": "68d2b2d5ce021944acca3192",
        //   "id": 4,
        //   "name": "Invalidated",
        //   "sortName": "invalidated"
        // };
        // if (this.isInvalidateSelected) {
        //   const exists = this.selected_statusids.some(item => item.id === invalidate.id);
        //   if (!exists) {
        //     this.selected_statusids.push(invalidate);
        //   }
        // } else {
        //   this.selected_statusids = this.selected_statusids.filter(
        //     item => item.id !== invalidate.id
        //   );
        // }
        // this.set_filter()
      },

    updateEmpEndDate(){
    },
    getSelectedColms(){
      let payload = {
         "companyId":this.checkProperty(this.getUserData, "companyDetails", "_id" ),
      }
        let path = 'company/get-employee-columns'
        this.$store.dispatch("commonAction", { data: payload, path: path })
        .then((response) => {
          this.isEmailSelected = response.showEmail
          this.isMidNameSelected = response.showMiddleName
          this.isTdSelected = response.showTerminationDate
        })
        .catch((error) => { });
    },
    enableCol(action, showMessage=true){
      let payload={
          "companyId":this.checkProperty(this.getUserData, "companyDetails", "_id" ),
          "showTerminationDate": this.isTdSelected,
          "showEmail": this.isEmailSelected,
          "showMiddleName": this.isMidNameSelected
      }

      let path = 'company/update-employee-columns'
       this.$store.dispatch("commonAction", { data: payload, path: path })
        .then((response) => {
          if(showMessage){
           // this.showToster({ message: response.message, isError: false });
          }
        })
        .catch((error) => { });

    },
    reinstateTerminatedEmp(userId, scope='') {
      const today = new Date();
      let payload = {
        userId: userId,
        reinstate: true,
        reinstatedOn: today,
        statusId: 2,
        statusName: "Active",
        today: today,
        employeeActivity: true
      };
      if(scope === 'restore'){
        payload['employeeRestore'] = true;
        payload['eventType'] = 'Restore';
      }else if(scope === 'undoTermination'){
        payload['undoTermination'] = true;
        payload['eventType'] = 'Undo Termination';
      }
      let path = "users/manage-status";
      this.loading = true;
      this.$store
        .dispatch("commonAction", { data: payload, path: path })
        .then((response) => {
          setTimeout(()=>{
            this.showRestoreConfirmationPopup = false;
            this.showUndoTerminationConfirmPopup = false;
          },400)
          this.showToster({ message: response.message, isError: false });
          this.loading = false;
          this.getbeneficiaries(true);
          this.errorMsg = "";
        })
        .catch((error) => {
          this.showToster({ message: error, isError: true });
          this.loading = false;
          this.errorMsg = error;
          this.showUndoTerminationConfirmPopup = false;
        });
    },

    showDetails(item) {
      if (item) {
        this.userDetails = item;
        this.$modal.show("userDetailsPopupModal");
      }
    },
    petitionlink() {},
    clearAlternateFields() {
      if (!this.checkProperty(this.permDetails, "isAltCombOfEduAndExpAccept")) {
        this.permDetails["altLevelOfEduDetails"] = null;
        this.permDetails["altLevelOfEduDetailsOther"] = "";
        this.permDetails["altAcceptExpInYears"] = null;
      }
    },
    clearAlternateOccupationFields() {
      if (!this.checkProperty(this.permDetails, "isExpInAltOccuAccept")) {
        this.permDetails["noOfExpMonthsInAltOccu"] = null;
      }
    },
    clearMinDegreeDetails() {
      if (this.checkProperty(this.permDetails, "minDegreeDetails", "id") != 8) {
        this.permDetails.minDegreeDetailsOther = "";
      }
    },
    clearAltLevelOfEduDetails() {
      if (
        this.checkProperty(this.permDetails, "altLevelOfEduDetails", "id") != 8
      ) {
        this.permDetails.altLevelOfEduDetailsOther = "";
      }
    },
    clearEduHighLevReqJobOppDetails() {
      if (
        this.checkProperty(
          this.permDetails,
          "eduHighLevReqJobOppDetails",
          "id"
        ) != 8
      ) {
        this.permDetails.eduHighLevReqJobOppDetailsOther = "";
      }
    },
    showRevertAction(tr) {
      this.userData = tr;
      this.showRevertPopup = true;
    },
    handleCloseRevertPopup(success = false) {
      this.showRevertPopup = false;
      if (success) {
        setTimeout(() => {
          this.getbeneficiaries(true);
        }, 10);
      }
    },
    updateData(docs, category) {
      if (category == "RFE") {
        this.rfeData["documents"] = docs;
        this.prefillRfeNoticeDoc();
        this.$validator.reset();
      }
      if (category == "PWD") {
        this.pwdResponse["documents"] = docs;
        this.prefillJobDetails();
        this.$validator.reset();
      }
      if (category == "permDocuments") {
        this.permDolDocs = docs;
        this.prefillPermDocData();
        this.$validator.reset();
      }
      if (category == "140Documents") {
        this.Dol140Docs = docs;
      }
    },
    openAddSponserPopUp() {
      // this.sponsor =null
      this.inviteSponser = true;
    },
    addNewSpr(newPet = "", id) {
      this.inviteSponserPopupShow(true);
    },
    inviteSponserPopupShow(action = true) {
      this.inviteSponser = action;
      if (!action) {
        this.selectedBeneficiary = null;
      }
    },
    sponsorUpdated() {
      this.resetRfeData(true);
      this.getbeneficiaryMasterDataList();
      // if(!this.checkProperty(this.beneficiaryInfo ,'email') && this.checkProperty(this.beneficiaryInfo ,'tempUser')==true){
      //   this.hideBeneforQues = false;
      //   this.fillTheQuestionnire = 'Petitioner'
      // }
    },
    closenewSponserPopup(selectedSponsor = null, type = "") {
      this.getSponserForCase();
      this.sponsor = selectedSponsor;
      this.inviteSponserPopupShow(false);
      if (type != "fromBeneficiaryList") {
        this.openNewbenFormPopup(true);
      }
    },
    searchspnsr(searchText = "") {
      let _self = this;
      this.selectedBeneficiary = null;
      //this.sponsor =null;
      let self = this;
      clearTimeout(self.debounce);
      self.debounce = setTimeout(() => {
        self.getSponserForCase(self, searchText);
      }, 900);
    },
    getSponserForCase(text = "") {
      let postData = {
        matcher: {
          title: text,
          statusList: [],
          branchIds: [],
          companyIds: [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          createdByIds: [],
          createdDateRange: [],
          roleIds: [51],
          statusIds: [],
          petitionTypeIds: [],
          petitionSubTypeIds: [],
          petitionCreatedDateRange: [],
          petitionStatusIds: [],
          getPetitionStats: true,
        },
        sorting: {
          path: "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          order: 1,
        },
        page: 1,
        perpage: 1000000,
        getMasterData: true,
        getBeneficiaryList: true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        branchId: "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        companyId: "", // Required when 'getMasterData' is true and roleIds are [50, 51]
      };
      this.enableAddNewBenTag = false;
      if (
        [4].indexOf(this.checkProperty(this.visatype, "id")) > -1 ||
        this.isPetitioner == false ||
        this.isPetitioner == "false"
      ) {
        postData["matcher"]["accountType"] = "Individual";
        postData["matcher"]["accountSubType"] = "Sponsor";
      }
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then((response) => {
          this.sponsorList = response.list;
          let filteredData = [];
          _.forEach(this.sponsorList, (item) => {
            if (item && (_.has(item, "name") || _.has(item, "email"))) {
              if (
                (_.has(item, "name") && item["name"].includes(text)) ||
                (_.has(item, "email") && item["email"].includes(text))
              ) {
                filteredData.push(item);
              } else {
                return false;
              }
            } else {
              return false;
            }
          });

          if (filteredData.length <= 0) {
            this.enableAddNewBenTag = true;
          }
          let sponsorList = _.cloneDeep(this.sponsorList);
          this.sponsorList = [];
          _.forEach(sponsorList, (item) => {
            if (this.checkProperty(item, "name")) {
              if (this.checkProperty(item, "email")) {
                item["name"] = item["name"] + " (" + item["email"] + ")";
              }
              this.sponsorList.push(item);
            }
          });
        });
    },
    changeperPage() {
      this.page = 1;
      this.getbeneficiaries(true);
    },
    clearReceivedDate(val) {
      if (val) {
        let startDate = moment(val);
        if (this.rfeData.rfeReceivedDate) {
          let endDate = moment(this.rfeData.rfeReceivedDate);
          if (startDate.isAfter(endDate, "day")) {
            this.rfeData.rfeReceivedDate = null;
          }
        }
      }
      // else{
      //   this.rfeData.rfeReceivedDate = null
      // }
    },
    peritioners_search_fun(searchValue) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.page = 1;
        this.getPetitioners(false, searchValue);
      }, 900);
    },
    resetRfeData(setrfeInternalCase = false) {
      this.prefilledKyes = [];
      this.documentUploading = false;
      //alert("ssd fsd");
      //   rfeData:{
      //   rfeCaseUscisDeadlineDate:null,
      //uscisReceiptNumber:'',
      //   rfeInternalCase:'externalCase',//'internalCase',
      //   "documents":[],
      //   "docs":{
      //     "copyOfRfe":[],
      //       "orgPetition":[],
      //       "petitionerDocs":[],
      //       "employmentDocs":[],
      //       "beneficiaryDocs":[],
      //       "other":[]

      //   },
      //   h1bCaseId:null
      // }

      if (setrfeInternalCase) {
        this.rfeData["rfeInternalCase"] = "internalCase";
        this.premiumProcessing = false;
      }
      this.rfeData["h1bCaseId"] = null;
      //rfeIssuedDate:null,rfeReceivedDate:null
      this.rfeData["rfeIssuedDate"] = null;
      this.rfeData["rfeReceivedDate"] = null;
      this.rfeData["rfeCaseUscisDeadlineDate"] = null;
      this.rfeData["uscisReceiptNumber"] = "";

      this.rfeData["documents"] = [];
      this.rfeData["docs"] = {
        copyOfRfe: [],
        orgPetition: [],
        petitionerDocs: [],
        employmentDocs: [],
        beneficiaryDocs: [],
        other: [],
      };
      this.rfeData["h1bCaseId"] = null;
    },
    emitUploadingAction(data) {
      if (_.has(data, "docMainCategory")) {
        _.map(this[data["docMainCategory"]], (item) => {
          if (item["fieldName"] == data["fieldName"]) {
            item = Object.assign(item, { fileUploading: false });
            item["fileUploading"] = data["action"];
          }
        });
      }
      this.checkSubmitBtn(data);
    },
    checkSubmitBtn(data) {
      this.documentUploading = false;
      if (_.has(data, "docMainCategory")) {
        _.forEach(this[data["docMainCategory"]], (item) => {
          if (_.has(item, "fileUploading") && item["fileUploading"]) {
            this.documentUploading = true;
            return false;
          }
        });
      }
    },
    prefillRfeNoticeDoc() {
      this.draftExtractInfo = null;
      var _dt;
      this.prefilledKyes = [];
      this.$validator.reset();
      if (this.checkProperty(this.rfeData, "documents", "length") > 0) {
        let path = "/petition/extract-lca-data-from-pdf";
        path = "/common/extract-data-from-pdf";
        //  9014077715 --- 325

        let postData = {
          category: "rfe_notice",
          docType: "rfe_notice",
          documents: [],
          lcaDocument: "",
        };

        let doc = this.rfeData["documents"][0];
        postData["lcaDocument"] = doc.path;
        postData["documents"].push(doc.path);
        //return doc.path;

        this.$vs.loading();
        this.$store
          .dispatch("commonAction", { data: postData, path: path })
          .then((response) => {
            this.$vs.loading.close();
            this.uploading = false;
            this.draftExtractInfo = response;
            if (
              this.checkProperty(this.draftExtractInfo, "uscisDeadlineDate")
            ) {
              this.rfeData["rfeCaseUscisDeadlineDate"] =
                this.draftExtractInfo["uscisDeadlineDate"]; //moment(this.draftExtractInfo['uscisDeadlineDate']).format("MM/DD/YYYY");
              this.prefilledKyes.push("rfeCaseUscisDeadlineDate");
            }

            //rfeIssuedDate:null,
            //rfeReceivedDate:null,

            if (this.checkProperty(this.draftExtractInfo, "rfeIssuedDate")) {
              this.rfeData["rfeIssuedDate"] =
                this.draftExtractInfo["rfeIssuedDate"];
              this.prefilledKyes.push("rfeIssuedDate");
            }
            if (this.checkProperty(this.draftExtractInfo, "rfeReceivedDate")) {
              this.rfeData["rfeReceivedDate"] =
                this.draftExtractInfo["rfeReceivedDate"];
              this.prefilledKyes.push("rfeReceivedDate");
            }

            if (
              this.checkProperty(this.draftExtractInfo, "uscisReceiptNumber")
            ) {
              this.rfeData["uscisReceiptNumber"] =
                this.draftExtractInfo["uscisReceiptNumber"];
              this.prefilledKyes.push("uscisReceiptNumber");
            }
          })
          .catch((errr) => {
            this.$vs.loading.close();
            this.pwdDocFormatError = errr;
            this.uploading = false;
          });
      }
    },
    getBenficiaryH1BCases() {
      this.rfeData.h1bCaseId = null;
      this.benficiaryH1BCases = [];
      let postData = {
        matcher: {
          getMasterDataOnly: true,
          rfeCases: false,
          searchString: "",
          statusIds: [24],
          beneficiaryIds: [],
          premiumProcessing: [],
          stateIds: [],
          locationIds: [],
          petitionerIds: [],
          branchIds: [],
          typeIds: [1],
          subTypeIds: [],
          //"getActiveCases":true,
          deadlineDateRange: [],
          getMissingDeadlines: false,
          statusList: [], //get only rfe
          intStatusIds: [],
          assignedUserIds: [],
          getFiledCases: false,
          countryIds: [],
        },
        page: 1,
        perpage: 25,
        sorting: { path: "updatedOn", order: -1 },
      };
      //this.checkProperty(this.visasubtype,'id') == 9 &&
      //alert(JSON.stringify(this.visatype));
      if (
        this.checkProperty(this.visatype, "id") == 9 &&
        (this.checkProperty(this.selectedBeneficiary, "_id") ||
          this.beneficiaryId)
      ) {
        if (this.checkProperty(this.selectedBeneficiary, "_id")) {
          postData["matcher"]["beneficiaryIds"] = [];
          postData["matcher"]["beneficiaryIds"].push(
            this.checkProperty(this.selectedBeneficiary, "_id")
          );
        } else if (this.beneficiaryId) {
          postData["matcher"]["beneficiaryIds"] = [];
          postData["matcher"]["beneficiaryIds"].push(this.beneficiaryId);
        }

        this.$store
          .dispatch("commonAction", {
            data: postData,
            path: "/petition-common/list",
          })
          .then((response) => {
            let list = [];
            // caseNo
            if (this.checkProperty(response, "list", "length") > 0) {
              list = response.list;
              list = _.map(list, (item) => {
                if (_.has(item, "caseNo")) {
                  item["name"] = item["caseNo"];
                  item["id"] = item["_id"];
                  return item;
                }
              });
            }
            this.benficiaryH1BCases = list;
          });
      }
    },
    updatedexpInYears() {
      if (this.checkProperty(this.permDetails, "expInYears")) {
        this.permDetails.expInYears = parseInt(this.permDetails.expInYears);
      }
    },
    addPermNewSkill() {
      this.skillTextError = false;
      if (this.newSkill && this.newSkill.trim() != "") {
        let skil = this.newSkill.trim();
        if (this.permDetails["skills"].indexOf(skil) <= -1) {
          this.permDetails["skills"].push(skil);
        }

        this.newSkill = "";
        this.addSkill = false;
      } else {
        this.skillTextError = true;
      }
    },
    removePermSkill(index) {
      this.permDetails["skills"].splice(index, 1);
      // this.$emit('input', this.value);
    },
    getEducationList() {
      this.$store
        .dispatch("getmasterdata", "education_types")
        .then((response) => {
          this.educationTypes = response;
        });
    },

    changedHoursPerWeek() {
      if (this.checkProperty(this.permDetails, "hoursPerWeek")) {
        this.permDetails["hoursPerWeek"] = parseInt(
          this.permDetails["hoursPerWeek"]
        );
      }
    },
    resetPermData(callFromPermDocDelete = false) {
      this.draftExtractInfo = null;
      let defaultPermDetails = {
        i140PriorityDate: null,
        permExpiryDate: null,
        minDegreeDetailsOther: null,
        isExpRequired: null,
        noOfExpMonths: "",
        isAltCombOfEduAndExpAccept: null,
        altLevelOfEduDetails: null,
        altLevelOfEduDetailsOther: "",
        altAcceptExpInYears: null,
        isExpInAltOccuAccept: null,
        noOfExpMonthsInAltOccu: null,
        eduHighLevReqJobOppDetails: null,
        eduHighLevReqJobOppDetailsOther: "",
        eduMajorFieldOfStudy: "",
        eduCompleteYear: "",
        eduInstitution: "",
        eduAddress: {
          line1: null,
          line2: null,
          aptType: null,
          locationId: null,
          locationDetails: null,
          stateId: null,
          stateDetails: null,
          countryId: null,
          countryDetails: null,
          zipcode: null,
        },

        socCode: "",
        socDetails: null,
        jobTitle: "",
        minDegreeDetails: null,
        minDegree: null,
        skills: [],
        majorFieldsOfStudy: "",
        expInYears: null,
        workAddresses: [
          {
            line1: null,
            line2: null,
            aptType: null,
            locationId: null,
            locationDetails: null,
            stateId: null,
            stateDetails: null,
            countryId: 231,
            countryDetails: {
              id: 231,
              shortName: "US",
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
            },
            zipcode: null,
          },
        ],
        fullTimePosition: false,
        hoursPerWeek: "",
        wageRate: "",
        payFrequency: "", // Year, Month, Bi-Weekly, Week, Hour
        description: "",
        permanentPosition: false,
        newPosition: false,
        permApplicationNo: "",
      };

      if (callFromPermDocDelete) {
        _.forEach(this.permDetails, (item, key) => {
          if (
            _.has(defaultPermDetails, key) &&
            this.permDocPreFilledKyes.indexOf(key) > -1
          ) {
            this.permDetails[key] = defaultPermDetails[key];
          }
        });
      } else {
        this.permDetails = _.cloneDeep(defaultPermDetails);
      }
      this.permDocPreFilledKyes = [];
      this.$validator.reset();
    },

    updatesocCode(item) {
      if (_.has(item, "id")) {
        this.permDetails["socCode"] = item["id"];
      }
    },
    getMasterSocList() {
      let query = {};
      query["page"] = 1;
      query["perpage"] = 10000;
      query["matcher"] = {
        getInactiveListAlso: true,
      };
      query["category"] = "soc_codes";

      this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
          this.masterSocList = response.list;

          //alert(this.perpage);
        })
        .catch(() => {
          this.masterSocList = [];
        });
    },
    //permDocPreFilledKyes
    prefillPermDocData(callJobDetails = false) {
      this.draftExtractInfo = null;
      let _self = this;
      this.formerrors.msg = "";
      this.permDocFormatError = "";
      var _dt;
      this.permDocPreFilledKyes = [];
      this.$validator.reset();
      if (this.permDolDocs.length > 0) {
        this.uploading = true;
        let path = "/common/extract-data-from-pdf";
        let postData = {
          docType: "perm",
          documents: [],
        };
        //postData['documents'] = this.pwdResponse['documents']
        _.forEach(this.permDolDocs, (doc) => {
          postData["documents"].push(doc.path);
          //return doc.path;
        });
        this.$vs.loading();
        this.$store
          .dispatch("commonAction", { data: postData, path: path })
          .then((response) => {
            this.uploading = false;
            let responseData = response["jobDetails"];
            _dt = _.cloneDeep(response["jobDetails"]);
            this.draftExtractInfo = response;
            _.forEach(this.permDetails, (item, key) => {
              if (_.has(responseData, key) && responseData[key]) {
                if (key == "wageRate" && responseData[key]) {
                  let wageRate = responseData[key];
                  const specialCharsRegex = /[^0-9.]/g;
                  // Use the replace() method to replace all special characters with an empty string
                  wageRate = wageRate.replace(specialCharsRegex, "");

                  this.permDetails["wageRate"] = parseFloat(wageRate);
                } else if (key == "socCode") {
                  this.permDocPreFilledKyes.push("socDetails");
                  this.permDetails["socDetails"] = _.find(this.masterSocList, {
                    id: parseInt(responseData[key]),
                  });
                } else if (
                  (key == "minDegree",
                  this.checkProperty(responseData, "minDegree"))
                ) {
                  this.permDetails["minDegree"] = responseData["minDegree"];
                  this.permDetails["minDegreeDetails"] = _.find(
                    this.educationTypes,
                    { id: parseInt(responseData["minDegree"]) }
                  );
                  this.permDocPreFilledKyes.push("minDegree");
                } else if (key == "skills") {
                  let skils = responseData[key].split(",");
                  this.permDetails["skills"] = _.map(skils, (skil) =>
                    skil.trim()
                  );
                  if (
                    this.checkProperty(this.permDetails, "skills", "length") > 0
                  ) {
                    this.permDocPreFilledKyes.push(key);
                  }
                } else if (key == "eduAddress") {
                  if (
                    responseData[key] &&
                    ((_.has(responseData[key], "countryDetails") &&
                      responseData[key]["countryDetails"]) ||
                      (_.has(responseData[key], "countryId") &&
                        responseData[key]["countryId"]))
                  ) {
                    if (
                      _.has(responseData[key], "line1") &&
                      responseData[key]["line1"]
                    ) {
                      this.permDetails["eduAddress"]["line1"] =
                        responseData[key]["line1"];
                    }
                    if (
                      _.has(responseData[key], "line2") &&
                      responseData[key]["line2"]
                    ) {
                      this.permDetails["eduAddress"]["line2"] =
                        responseData[key]["line2"];
                    }
                    if (
                      _.has(responseData[key], "aptType") &&
                      responseData[key]["aptType"]
                    ) {
                      this.permDetails["eduAddress"]["aptType"] =
                        responseData[key]["aptType"];
                    }
                    if (
                      _.has(responseData[key], "locationId") &&
                      responseData[key]["locationId"]
                    ) {
                      this.permDetails["eduAddress"]["locationId"] =
                        responseData[key]["locationId"];
                    }
                    if (
                      _.has(responseData[key], "locationDetails") &&
                      responseData[key]["locationDetails"]
                    ) {
                      this.permDetails["eduAddress"]["locationDetails"] =
                        responseData[key]["locationDetails"];
                    }
                    if (
                      _.has(responseData[key], "stateId") &&
                      responseData[key]["stateId"]
                    ) {
                      this.permDetails["eduAddress"]["stateId"] =
                        responseData[key]["stateId"];
                    }
                    if (
                      _.has(responseData[key], "stateDetails") &&
                      responseData[key]["stateDetails"]
                    ) {
                      this.permDetails["eduAddress"]["stateDetails"] =
                        responseData[key]["stateDetails"];
                    }
                    if (
                      _.has(responseData[key], "countryId") &&
                      responseData[key]["countryId"]
                    ) {
                      this.permDetails["eduAddress"]["countryId"] =
                        responseData[key]["countryId"];
                    }
                    if (
                      _.has(responseData[key], "countryDetails") &&
                      responseData[key]["countryDetails"]
                    ) {
                      this.permDetails["eduAddress"]["countryDetails"] =
                        responseData[key]["countryDetails"];
                    }
                    if (
                      _.has(responseData[key], "zipcode") &&
                      responseData[key]["zipcode"]
                    ) {
                      this.permDetails["eduAddress"]["zipcode"] =
                        responseData[key]["zipcode"];
                    }
                    this.permDocPreFilledKyes.push("eduAddress");
                  }
                } else {
                  this.permDetails[key] = responseData[key];
                  this.permDocPreFilledKyes.push(key);
                }
                this.updatedexpInYears();
              }
            });

            this.permDetails = _.cloneDeep(this.permDetails);
            if (this.draftExtractInfo && this.draftExtractInfo.jobDetails) {
              this.permExpiryDate = this.checkProperty(
                this.draftExtractInfo,
                "jobDetails",
                "dueDate"
              );
              this.permDetails["permExpiryDate"] = this.checkProperty(
                this.draftExtractInfo,
                "jobDetails",
                "dueDate"
              );
            }

            // setTimeout(function(){
            //   if(_self.checkProperty(responseData.workAddresses, 'length') > 0  && _self.checkProperty(responseData.workAddresses[0], 'locationId')){
            //     _self.permDetails.workAddresses[0].locationId = responseData.workAddresses[0].locationId;
            //   }
            //   if(_self.checkProperty(responseData.workAddresses, 'length') > 0  && _self.checkProperty(responseData.workAddresses[0], 'locationDetails')){
            //     _self.permDetails.workAddresses[0].locationDetails = responseData.workAddresses[0].locationDetails;
            //   }
            // })

            if (callJobDetails) {
              this.prefillDataFromJobDetails();
            } else {
              this.$vs.loading.close();
            }
          })
          .catch((errr) => {
            //this.$vs.loading.close();
            this.permDocFormatError = errr;
            // this.formerrors.msg =errr
            // this.prefillJobDetailsError = errr
            //this.showToster({message:errr,isError:true });
            this.uploading = false;
            if (callJobDetails) {
              this.prefillDataFromJobDetails();
            } else {
              this.$vs.loading.close();
            }
          });
      }
    },
    prefillDataFromJobDetails() {
      let _self = this;
      let jobDetails = _.cloneDeep(this.permJobDetails);
      let baseValues = ["", "", " ", null, [], [], false];
      try {
        _.forEach(this.permDetails, (item, key) => {
          if (
            _.has(jobDetails, key) &&
            jobDetails[key] &&
            ((baseValues.indexOf(this.permDetails[key]) > -1 &&
              key != "skills") ||
              (key == "skills" &&
                this.checkProperty(this.permDetails, "skills", "length") <= 0))
          ) {
            if (key == "wageRate" && jobDetails[key]) {
              let wageRate = jobDetails[key];
              const specialCharsRegex = /[^0-9.]/g;
              wageRate = wageRate.replace(specialCharsRegex, "");
              this.permDetails["wageRate"] = parseFloat(wageRate);
            } else if (
              key == "minDegree" &&
              this.checkProperty(jobDetails, "minDegree")
            ) {
              this.permDetails["minDegree"] = jobDetails["minDegree"];
              this.permDetails["minDegreeDetails"] = _.find(
                this.educationTypes,
                { id: parseInt(jobDetails["minDegree"]) }
              );
            } else if (key == "socCode") {
              this.permDetails["socDetails"] = _.find(this.masterSocList, {
                id: parseInt(jobDetails[key]),
              });
            } else if (key == "skills") {
              if (
                jobDetails[key] &&
                this.checkProperty(jobDetails[key], "length") > 0
              ) {
                this.permDetails["skills"] = jobDetails[key];
              }
            } else {
              this.permDetails[key] = jobDetails[key];
            }
            this.updatedexpInYears();
          }
        });
        if (
          this.checkProperty(jobDetails, "workAddresses") &&
          this.checkProperty(jobDetails, "workAddresses", "length") > 0 &&
          !this.checkProperty(this.permDetails["workAddresses"][0], "line1") &&
          !this.checkProperty(this.permDetails["workAddresses"][0], "line2") &&
          !this.checkProperty(
            this.permDetails["workAddresses"][0],
            "locationId"
          ) &&
          !this.checkProperty(
            this.permDetails["workAddresses"][0],
            "locationDetails"
          ) &&
          !this.checkProperty(
            this.permDetails["workAddresses"][0],
            "stateDetails"
          ) &&
          !this.checkProperty(
            this.permDetails["workAddresses"][0],
            "stateId"
          ) &&
          !this.checkProperty(this.permDetails["workAddresses"][0], "zipcode")
        ) {
          if (
            jobDetails["workAddresses"][0] &&
            ((_.has(jobDetails["workAddresses"][0], "countryDetails") &&
              jobDetails["workAddresses"][0]["countryDetails"]) ||
              (_.has(jobDetails["workAddresses"][0], "countryId") &&
                jobDetails["workAddresses"][0]["countryId"]))
          ) {
            if (
              _.has(jobDetails["workAddresses"][0], "line1") &&
              jobDetails["workAddresses"][0]["line1"]
            ) {
              this.permDetails["workAddresses"][0]["line1"] =
                jobDetails["workAddresses"][0]["line1"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "line2") &&
              jobDetails["workAddresses"][0]["line2"]
            ) {
              this.permDetails["workAddresses"][0]["line2"] =
                jobDetails["workAddresses"][0]["line2"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "aptType") &&
              jobDetails["workAddresses"][0]["aptType"]
            ) {
              this.permDetails["workAddresses"][0]["aptType"] =
                jobDetails["workAddresses"][0]["aptType"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "countryId") &&
              jobDetails["workAddresses"][0]["countryId"]
            ) {
              this.permDetails["workAddresses"][0]["countryId"] =
                jobDetails["workAddresses"][0]["countryId"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "countryDetails") &&
              jobDetails["workAddresses"][0]["countryDetails"]
            ) {
              this.permDetails["workAddresses"][0]["countryDetails"] =
                jobDetails["workAddresses"][0]["countryDetails"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "stateId") &&
              jobDetails["workAddresses"][0]["stateId"]
            ) {
              this.permDetails["workAddresses"][0]["stateId"] =
                jobDetails["workAddresses"][0]["stateId"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "stateDetails") &&
              jobDetails["workAddresses"][0]["stateDetails"]
            ) {
              this.permDetails["workAddresses"][0]["stateDetails"] =
                jobDetails["workAddresses"][0]["stateDetails"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "locationId") &&
              jobDetails["workAddresses"][0]["locationId"]
            ) {
              this.permDetails["workAddresses"][0]["locationId"] =
                jobDetails["workAddresses"][0]["locationId"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "locationDetails") &&
              jobDetails["workAddresses"][0]["locationDetails"]
            ) {
              this.permDetails["workAddresses"][0]["locationDetails"] =
                jobDetails["workAddresses"][0]["locationDetails"];
            }
            if (
              _.has(jobDetails["workAddresses"][0], "zipcode") &&
              jobDetails["workAddresses"][0]["zipcode"]
            ) {
              this.permDetails["workAddresses"][0]["zipcode"] =
                jobDetails["workAddresses"][0]["zipcode"];
            }
          }
        }
        if (this.i140PriorityDate) {
          this.permDetails["i140PriorityDate"] = this.i140PriorityDate;
        }
        this.permDetails = _.cloneDeep(this.permDetails);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },

    moveToTrash(val) {
      if (val) {
        this.selectedPwdId = null;
        this.isLinkPwd = false;
      }
    },
    changePwdDoc(val) {
      if (val) {
        this.isLinkPwd = false;
        this.selectedPwdId = null;
      }
      this.setPwdFilled(true);
    },
    linkExistingPwd(val) {
      if (val) {
        this.isPwdFiled = false;
      }
    },
    assignPwdValue(val) {
      if (val == "havingPWD") {
        this.isPwdFiled = true;
        this.hasJobDetails = true;
      } else {
        this.isPwdFiled = false;
        this.hasJobDetails = false;
      }
      this.pwdStatus = "";
      this.resetPwdResponse();
      // this.hasJobDetails=false
      this.setJobDetails(false);
      this.selectedPwdId = null;
    },
    emitPwd(val) {
      if (this.checkProperty(val, "_id")) {
        this.selectedPwdId = val;
      } else {
        this.isLinkPwd = false;
        this.selectedPwdId = null;
      }
    },
    searchMe() {
      let self = this;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        self.page = 1;
        self.getbeneficiaries(true);
      }, 900);
    },
    conformDeleteBene(item, statusId = 0) {
      if (this.getUserRoleId==12) return 
      this.selectedStatus = statusId;
      this.popUpText = "";
      this.popUpTitle = "";
      if (this.selectedStatus == 2) {
        this.popUpText = " Are you sure Active this Beneficiary?";
        this.popUpTitle = "Active ";
      }
      if (this.selectedStatus == 3) {
        this.popUpText = "Are you sure Inactive this Beneficiary?";
        this.popUpTitle = "Inactive ";
      }

      if (this.selectedStatus == 4) {
        this.popUpText = "Are you sure Delete this Beneficiary?";
        this.popUpTitle = " Invalidate Employee";
      }

      this.loading = false;
      this.deleteBeneficiaryPopup = true;
      this.$validator.reset()
      this.selectedBeneficiaryItem = item;
      this.errorMsg = "";
    },
    deleteBeneficiary(statusId = 0) {
        this.$validator.validateAll().then((result) => {
        if (result) {
          let postData = {};
      postData["userId"] = this.selectedBeneficiaryItem._id;
      postData["statusId"] = this.selectedStatus;
      postData["statusName"] = "";
      if (this.selectedStatus == 2) {
        postData["statusName"] = "Active";
      }
      if (this.selectedStatus == 3) {
        postData["statusName"] = "Inactive";
      }

      if (this.selectedStatus == 4) {
        postData["statusName"] = "Delete";
        postData['change'] = this.checkProperty(this.selectedReason, 'name')
        postData['commentForChange'] = this.reasonText
        postData['employeeActivity'] = true
        postData['eventType'] = 'Invalidate'
      }
      let path = "users/manage-status";
      this.loading = true;
      this.$store
        .dispatch("commonAction", { data: postData, path: path })
        .then((response) => {
          this.showToster({ message: response.message, isError: false });
          this.loading = false;
          this.deleteBeneficiaryPopup = false;
          this.selectedBeneficiaryItem = null;
          this.getbeneficiaries(true);
          this.errorMsg = "";
          this.reasonText= ''
          this.selectedReason = null
        })
        .catch((error) => {
          //this.showToster({message:error,isError:true });
          this.loading = false;
          this.errorMsg = error;
        });
        }
      })
      
    },
    terminateEmp(emp, fromEdit=false) {
      if (this.getUserRoleId==12) return 
      if(fromEdit){
        this.editTermination = true
      }else{
        this.editTermination = false
      }
      if(emp.terminatedOn){
        this.terminatedOn = emp.terminatedOn
      }else{
        this.terminatedOn = new Date().toISOString().split('T')[0]
      }
      this.selectedBeneficiaryItem = emp;
      this.terminatePopup = true;
    },    

    closeTerminateEE() {
      this.selectedBeneficiaryItem = null;
      this.terminatePopup = false;
      this.terminatedOn = "";
    },
    confirmTerminate() {
        const terminated = new Date(this.terminatedOn);
        const hired = new Date(this.selectedBeneficiaryItem.hiredOn);
        if (terminated < hired) {
          this.showToster({ 
            message: 'Termination Date cannot be earlier than Hire Date.', 
            isError: true 
          });
          return;
        }
      this.$validator.validateAll("terminateEmployee").then((result) => {
        if (result) {
          let payload = {
            userId: this.checkProperty(this.selectedBeneficiaryItem, "_id"),
            statusId: 5,
            statusName: "Terminated",
            terminatedOn: this.terminatedOn,
            employeeActivity: true,
            eventType: this.editTermination ? 'Edit Termination' : 'Terminate'
          };
          this.terminteEEloading = true;
          this.$store
            .dispatch("commonAction", {
              data: payload,
              path: "users/manage-status",
            })
            .then((response) => {
              this.showToster({ message: response.message, isError: false });
              this.terminteEEloading = false;
              this.getbeneficiaries();
              this.closeTerminateEE();
            })
            .catch((error) => {
              console.log(" terminate errr --- ", error);
              this.showToster({ message: error, isError: true });
              this.terminteEEloading = false;
            });
        }
      });
    },
    classificationfun() {
      let Payload = {
        matcher: {
          searchString: "",
          typeIds: [3], //[3],
          subTypeIds: [16], // [16],
          classificationList: [], // ["EB3"],
          petitionerIds: [],
          beneficiaryIds: [],
          statusIds: [],
          createdDateRange: [],
          premiumProcessing: [],
        },
      };
      //  if(this.visatype.id && this.visasubtype.id){
      //    Payload["matcher"]["typeIds"] = [this.visatype.id];
      //    Payload["matcher"]["subTypeIds"] = [this.visasubtype.id];
      //  }
      //  if(this.selectedPetitioner && _.has(this.selectedPetitioner,'_id')){
      //    Payload["matcher"]["petitionerIds"] = [this.selectedPetitioner._id]
      //  }
      if (this.selectedBeneficiary && _.has(this.selectedBeneficiary, "_id")) {
        Payload["matcher"]["beneficiaryIds"] = [this.selectedBeneficiary._id];
      }
      if (this.classification) {
        Payload["matcher"]["classificationList"] = [this.classification];
      }

      this.newPetitionFormSubmited = true;
      this.$store
        .dispatch("getList", {
          data: Payload,
          path: "/petition-common/get-case-count",
        })
        .then((response) => {
          this.classificationResultList = response;

          if (this.classificationResultList > 0) {
            this.classificationpopup = true;
            this.newPetitionFormSubmited = false;
          } else {
            this.classificationpopup = false;
            this.newPetitionFormSubmited = false;
            this.createNewPetition(true);
          }
        })
        .catch((err) => {
          this.classificationpopup = false;
          this.newPetitionFormSubmited = false;
        });
    },
    getCommonMessages() {
      let payLoad = {
        category: ["COMMON_MESSAGES"],
      };
      this.$store
        .dispatch("commonAction", { data: payLoad, path: "/messages/list" })
        .then((response) => {
          if (
            _.has(response["messages"]["COMMON_MESSAGES"], "i140DuplicateCase")
          ) {
            this.i140CreationMessage =
              response["messages"]["COMMON_MESSAGES"]["i140DuplicateCase"];
          }
        })
        .catch((error) => {});
    },
    getCategoryForCase() {
      let item = {
        matcher: {},
        page: this.page,
        perpage: 10000,
        category: "case_category",
      };
      this.$store.dispatch("getMasterData", item).then((response) => {
        this.categoryList = response.list;
      });
    },
    loadingFields(item) {
      this.$refs["jobComponent"].checkVislibilty(item);
    },
    resetPrefedKyes() {
      // this.pwdStatus = ''
      this.disablePWDstatus = false;
      let tempJobDetails = {
        wageRate: "",
        socOccuTitle: "",
        preferredSocOccuTitle: "",

        socCode: "",
        jobTitle: "",
        preferredSocCode: "",
        preferredSocCodeDetails: null,
        classification: "",
        description: "",
        skills: [],
        minDegree: "",
        majorFieldsOfStudy: "",
        expInYears: "",
        altJobRequirements: {
          // Are alternate sets of Education, Training, and/or Experience accepted? "Yes", "No"

          areAltSetsOfEducation: "", // { type: String},
          altevelOfEducation: null, //{ type: Schema.Types.ObjectId, default: null  }, //0bjectId
          altevelOfEducationDetails: null,
          usDiplomaOrDegreeAccepted: "", //{type: String},
          majorsOrFieldsOfStudyAccepted: "", //{type: String},
          isAltTrainingForTheJobOpporAccepted: "", //"Yes" Or "No"
          noOfMonthsOfAltTrainingAccepted: null, //{type: String},
          filedsOrNamesOfTrainingAccepted: "", //{ type: String },
          altEmpExpAccepted: "", //"Yes" Or "No"
          noOfMonthsAltEmpExpAccepted: null,
          splSkillOrOtherRequi: "",
          ForeignLanguage: "",
          LicenseCertification: "",
          residencyFellowship: "",
          otherSplSkillsOrRequi: "",
        },
        workAddresses: [
          {
            companyName: "",
            line1: "",
            line2: "",
            aptType: "",
            locationId: "",
            stateId: "",
            countryId: "",
            zipcode: "",
            locationDetails: {
              id: "",
              name: "",
              stateId: "",
              countryId: "",
            },
            stateDetails: {
              id: "",
              name: "",
              shortName: "",
              countryId: "",
            },
            countryDetails: {
              id: 231,
              shortName: "US",
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
            },
            workLocation: true,
          },
        ],
      };
      _.forEach(this.jobDetails, (item, key) => {
        if (this.prefilledKyes.indexOf(key) > -1) {
          this.jobDetails[key] = null;
          if (_.has(tempJobDetails, key)) {
            this.jobDetails[key] = tempJobDetails[key];
          } else {
            this.jobDetails[key] = null;
          }
        }
      });

      if (this.prefilledKyes.indexOf("issuedDate") > -1) {
        this.pwdResponse["issuedDate"] = null;
      }
      if (this.prefilledKyes.indexOf("receivedDate") > -1) {
        this.pwdResponse["receivedDate"] = null;
      }
      if (this.prefilledKyes.indexOf("dueDate") > -1) {
        this.pwdResponse["dueDate"] = null;
      }
      if (this.prefilledKyes.indexOf("pwdDocCaseNo") > -1) {
        this.pwdResponse["pwdDocCaseNo"] = null;
      }

      this.prefilledKyes = [];
      this.$validator.reset();
    },
    prefillJobDetails() {
      this.draftExtractInfo = null;
      var _dt;
      this.$validator.reset();
      this.pwdStatus = "";
      this.prefilledKyes = [];
      if (this.pwdResponse.documents.length > 0) {
        this.uploading = true;
        let path = "/common/extract-data-from-pdf";
        let postData = {
          docType: "pwd",
          documents: [],
        };
        //postData['documents'] = this.pwdResponse['documents']
        _.forEach(this.pwdResponse["documents"], (doc) => {
          postData["documents"].push(doc.path);
          //return doc.path;
        });
        this.$store
          .dispatch("commonAction", { data: postData, path: path })
          .then((response) => {
            this.uploading = false;
            let responseData = response["jobDetails"];
            this.draftExtractInfo = response;
            _.forEach(this.jobDetails, (item, key) => {
              if (_.has(responseData, key) && responseData[key]) {
                this.jobDetails[key] = responseData[key];
                this.prefilledKyes.push(key);
              }
            });
            _.forEach(this.pwdResponse, (item, key) => {
              if (_.has(responseData, key) && responseData[key]) {
                this.pwdResponse[key] = responseData[key];
                this.prefilledKyes.push(key);
              }
            });

            if (this.checkProperty(responseData, "pwdStatus")) {
              this.pwdStatus = this.checkProperty(responseData, "pwdStatus");
              this.disablePWDstatus = true;
              this.loadingFields(this.pwdStatus);
            } else {
              this.disablePWDstatus = false;
            }

            var _self = this;

            setTimeout(function () {
              if (_.has(responseData, "issuedDate")) {
                _self.pwdResponse["issuedDate"] = _.cloneDeep(
                  responseData["issuedDate"]
                );
              }
              if (_.has(responseData, "receivedDate")) {
                _self.pwdResponse["receivedDate"] = _.cloneDeep(
                  responseData["receivedDate"]
                );
              }
              if (_.has(responseData, "dueDate")) {
                _self.pwdResponse["dueDate"] = _.cloneDeep(
                  responseData["dueDate"]
                );
              }

              if (_.has(responseData, "pwdDocCaseNo")) {
                _self.pwdResponse["pwdDocCaseNo"] = _.cloneDeep(
                  responseData["pwdDocCaseNo"]
                );
                _self.prefilledKyes.push("pwdDocCaseNo");
              }

              _self.jobDetails.workAddresses[0].stateDetails =
                responseData.workAddresses[0].stateDetails;
              _self.jobDetails.workAddresses[0].stateId =
                responseData.workAddresses[0].stateId;
            }, 500);

            setTimeout(function () {
              _self.jobDetails.workAddresses[0].locationId =
                responseData.workAddresses[0].locationId;
              _self.jobDetails.workAddresses[0].locationDetails =
                responseData.workAddresses[0].locationDetails;
            }, 800);

            this.jobDetails = _.cloneDeep(this.jobDetails);
          })
          .catch((errr) => {
            this.prefillJobDetailsError = errr;
            //this.showToster({message:errr,isError:true });
            this.uploading = false;
          });
      }
    },
    updateissuedDate(val) {
      if (val) {
        if (this.pwdResponse["receivedDate"]) {
          let startData = moment(val);
          let endData = moment(this.pwdResponse["receivedDate"]);
          if (startData.isAfter(endData, "day")) {
            this.pwdResponse["receivedDate"] = null;
          }
        }
        if (this.pwdResponse["dueDate"]) {
          let startDate = moment(val);
          let endDate = moment(this.pwdResponse["dueDate"]);
          if (startDate.isAfter(endDate, "day")) {
            this.pwdResponse["dueDate"] = null;
          }
        }
      } else {
        this.pwdResponse.dueDate = null;
      }
    },
    resetPwdResponse(fromInput = false) {
      if (fromInput) {
        this.pwdResponse["issuedDate"] = null;
        this.pwdResponse["receivedDate"] = null;
        this.pwdResponse["dueDate"] = null;
        this.pwdResponse["description"] = "";
        this.pwdResponse["pwdDocCaseNo"] = "";
        this.pwdResponse["documentType"] = "Original";
      } else {
        this.pwdResponse = {
          issuedDate: null,
          receivedDate: null,
          dueDate: null,
          description: "",
          documents: [],
          documentType: "Original",
          pwdDocCaseNo: "",
        };
      }
    },
    setPwdFilled(callFromCheckBox = false) {
      if (!callFromCheckBox) {
        this.isPwdFiled = false;
      }
      this.pwdStatus = "";
      this.resetPwdResponse();
      this.hasJobDetails = false;
      this.setJobDetails(false);
      this.hasJobDetails = this.isPwdFiled;
      this.$validator.reset();
    },
    setJobDetails(item) {
      if (!item) {
        this.jobDetails = {
          wageRate: "",
          jobTitle: "",
          socCode: "",
          socCodeDetails: null,
          preferredSocCode: "",
          socOccuTitle: "",
          preferredSocOccuTitle: "",
          preferredSocCodeDetails: null,
          classification: "",
          description: "",
          skills: [],
          minDegree: "",
          majorFieldsOfStudy: "",
          expInYears: "",
          altJobRequirements: {
            // Are alternate sets of Education, Training, and/or Experience accepted? "Yes", "No"

            areAltSetsOfEducation: "", // { type: String},
            altevelOfEducation: null, //{ type: Schema.Types.ObjectId, default: null  }, //0bjectId
            altevelOfEducationDetails: null,
            usDiplomaOrDegreeAccepted: "", //{type: String},
            majorsOrFieldsOfStudyAccepted: "", //{type: String},
            isAltTrainingForTheJobOpporAccepted: "", //"Yes" Or "No"
            noOfMonthsOfAltTrainingAccepted: null, //{type: String},
            filedsOrNamesOfTrainingAccepted: "", //{ type: String },
            altEmpExpAccepted: "", //"Yes" Or "No"
            noOfMonthsAltEmpExpAccepted: null,
            splSkillOrOtherRequi: "",
            ForeignLanguage: "",
            LicenseCertification: "",
            residencyFellowship: "",
            otherSplSkillsOrRequi: "",
          },
          workAddresses: [
            {
              companyName: "",
              line1: "",
              line2: "",
              aptType: "",
              locationId: "",
              stateId: "",
              countryId: "",
              zipcode: "",
              locationDetails: {
                id: "",
                name: "",
                stateId: "",
                countryId: "",
              },
              stateDetails: {
                id: "",
                name: "",
                shortName: "",
                countryId: "",
              },
              countryDetails: {
                id: 231,
                shortName: "US",
                name: "United States",
                phoneCode: 1,
                order: 1,
                currencySymbol: "$",
                currencyCode: "USD",
                zipcodeLength: 5,
              },
              workLocation: true,
            },
          ],
        };
      }
    },
    checkBenPermStatus() {
      this.resetPermData();
      if (this.checkProperty(this.visasubtype, "id") == 18) {
        this.sponsor = null;
        this.getSponserForCase();
      }
      if (this.checkProperty(this.visasubtype, "id") != 15) {
        this.isPwdFiled = false;
        this.setPwdFilled();
      }
      this.permDolDocs = [];
      this.responsePermId = "";
      this.i140PriorityDate = null;
      this.permExpiryDate = null;
      this.permDocRequired = false;
      this.formerrors.msg = "";
      this.enableSubmitBtn = true;
      (this.Doc140Required = false), (this.response140Id = "");
      this.Dol140Docs = [];
      if (
        this.checkProperty(this.visatype, "id") == 3 &&
        this.checkProperty(this.visasubtype, "id") == 16 &&
        this.checkProperty(this.selectedBeneficiary, "_id")
      ) {
        let postData = {
          userId: this.checkProperty(this.selectedBeneficiary, "_id"),
        };
        this.$store
          .dispatch("commonAction", {
            data: postData,
            path: "/perm/get-perm-filed-docs",
          })
          .then((response) => {
            let responseData = response;

            if (
              this.checkProperty(responseData, "code") == "REQUIRED_PERM_DOCS"
            ) {
              this.permDocRequired = true;
              this.enableSubmitBtn = true;
            } else {
              if (this.checkProperty(responseData, "permId")) {
                if (
                  this.checkProperty(responseData, "permDocs", "length") > 0
                ) {
                  this.responsePermId = this.checkProperty(
                    responseData,
                    "permId"
                  );
                  this.permDolDocs = this.checkProperty(
                    responseData,
                    "permDocs"
                  );
                  this.enableSubmitBtn = true;
                  this.i140PriorityDate = this.checkProperty(
                    responseData,
                    "i140PriorityDate"
                  );
                  this.permExpiryDate = this.checkProperty(
                    responseData,
                    "expiryDate"
                  );
                  if (this.checkProperty(responseData, "jobDetails")) {
                    this.permJobDetails = this.checkProperty(
                      responseData,
                      "jobDetails"
                    );
                  }
                  this.permDocRequired = true;
                  if (this.checkProperty(this.permDolDocs, "length") > 0) {
                    this.prefillPermDocData(true);
                  } else {
                    if (this.checkProperty(responseData, "jobDetails")) {
                      this.prefillDataFromJobDetails();
                    }
                  }
                } else {
                  this.formerrors.msg = "Unable to create the I-140 Case";
                  this.enableSubmitBtn = false;
                }
                if (
                  this.checkProperty(
                    responseData,
                    "jobDetails",
                    "classification"
                  )
                ) {
                  this.classification = this.checkProperty(
                    responseData,
                    "jobDetails",
                    "classification"
                  );
                }
              } else {
                this.formerrors.msg = "Unable to create the I-140 Case";
                this.enableSubmitBtn = false;
              }
            }
          })
          .catch((error) => {
            this.formerrors.msg = error;
            this.enableSubmitBtn = false;
          });
      }
      if (
        this.checkProperty(this.visatype, "id") == 3 &&
        this.checkProperty(this.visasubtype, "id") == 17 &&
        this.checkProperty(this.selectedBeneficiary, "_id")
      ) {
        this.Dol140Docs = [];
        (this.Doc140Required = false), (this.formerrors.msg = "");
        this.enableSubmitBtn = true;
        let postData = {
          userId: this.checkProperty(this.selectedBeneficiary, "_id"),
          type: this.checkProperty(this.visatype, "id"),
          subType: this.checkProperty(this.visasubtype, "id"),
        };
        this.$store
          .dispatch("commonAction", {
            data: postData,
            path: "/petition/get-i140-filed-docs",
          })
          .then((response) => {
            let responseData = response;
            if (this.checkProperty(responseData, "code") == "REQUIRED_DOCS") {
              this.Doc140Required = true;
              this.enableSubmitBtn = true;
            } else {
              if (this.checkProperty(responseData, "i140Id")) {
                if (
                  this.checkProperty(responseData, "i140Docs", "length") > 0
                ) {
                  this.response140Id = this.checkProperty(
                    responseData,
                    "i140Id"
                  );
                  this.Dol140Docs = this.checkProperty(
                    responseData,
                    "i140Docs"
                  );
                  this.enableSubmitBtn = true;
                } else {
                  this.formerrors.msg = "Unable to create the I-485 Case";
                  this.enableSubmitBtn = false;
                }
              } else {
                this.formerrors.msg = "Unable to create the I-485 Case";
                this.enableSubmitBtn = false;
              }
            }
          })
          .catch((error) => {
            this.formerrors.msg = error;
            this.enableSubmitBtn = false;
          });
      }
    },
    upload(fils, category = "") {
      this.draftExtractInfo = null;
      this.pwdDocFormatError = "";
      let model = _.cloneDeep(fils);
      this.value = [];
      var _current = this;
      // this.$vs.loading();

      let efiles = [];
      efiles = _.filter(model, (e) => {
        return e.url != null && e.url != "";
      });
      let nfiles = _.filter(model, (e) => {
        return e.url == null || e.url == undefined;
      });

      let mapper = nfiles.map(
        (item) =>
          (item = {
            name: item.name,
            file: item.file ? item.file : null,
            url: item.url ? item.url : "",
            path: item.path ? item.path : "",
            status:
              item.status === false || item.status === true
                ? item.status
                : true,
            mimetype: item.type ? item.type : item.mimetype,
          })
      );
      let tempFiles = [];
      if (mapper.length > 0) {
        this.uploading = true;
        let count = 0;
        mapper.forEach((doc, index) => {
          if (
            (category == "RFE" ||
              category == "PWD" ||
              category == "permDocuments") &&
            !(doc.mimetype == "application/pdf")
          ) {
            this.pwdDocFormatError = "Upload only pdf documents";
            if (category == "permDocuments") {
              this.formerrors.msg = "Upload only pdf documents";
              this.permDocFormatError = "Upload only pdf documents";
            }

            this.uploading = false;

            return false;
          }
          let formData = new FormData();
          formData.append("files", doc.file);
          formData.append("secureType", "private");
          formData.append("getDetails", true);
          count++;

          this.$store.dispatch("uploadS3File", formData).then((response) => {
            response.data.result.forEach((urlGenerated) => {
              //alert(JSON.stringify(urlGenerated))
              //  this.CommentPayload.documents.push(urlGenerated)
              // if (  _.has(urlGenerated, "name") &&  tempFiles.indexOf(urlGenerated["name"]) <= -1 ) {
              tempFiles.push(urlGenerated["name"]);
              if (category == "RFE") {
                this.rfeData["documents"] = [];
                this.rfeData["documents"].push(urlGenerated);
                this.prefillRfeNoticeDoc();
              }
              if (category == "PWD") {
                this.pwdResponse["documents"] = [];
                this.pwdResponse["documents"].push(urlGenerated);
                this.prefillJobDetails();
                _current.$validator.reset();
              }
              if (category == "permDocuments") {
                this.permDolDocs = [];
                this.permDolDocs.push(urlGenerated);
                this.prefillPermDocData();
              }
              if (category == "140Documents") {
                this.Dol140Docs.push(urlGenerated);
              }

              //   }
              doc.url = urlGenerated;
              doc.path = urlGenerated;
              doc["mimetype"] = urlGenerated["mimetype"];
              doc["type"] = urlGenerated["mimetype"];
              delete doc.file;
              mapper[index] = doc;
            });
            if (index >= mapper.length - 1) {
              this.uploading = false;
              // _current.$vs.loading.close();
            }
          });
        });
        if (efiles.length > 0) efiles.push(...mapper);
        //this.CommentPayload["documents"] = efiles
      }
    },
    remove(item, data, filindex) {
      this.draftExtractInfo = null;
      data.splice(filindex, 1);
      this.disablePWDstatus = false;

      this.removeFileFromS3(item);
    },

    getvisaforNewCase() {
      let item = {
        matcher: {
          // "searchString":this.searchtxt,

          getActiveList: true,
        },
        page: 1,
        perpage: this.perpage,
        category: "petition_types",
      };
      this.visatype = null;
      this.$store.dispatch("getMasterData", item).then((response) => {
        if ([51].indexOf(this.loginRoleId) > -1) {
          this.activeVisatypes = _.filter(response.list, (item) => {
            return item.id != 3;
          });
        } else {
          this.activeVisatypes = response.list;
        }
        this.activeVisatypes = _.filter(this.activeVisatypes, (item) => {
          return [2, 4, 11].indexOf(item.id) <= -1;
          // return item.id !== 2 && item.id !== 4;
        });
        if (this.checkProperty(this.activeVisatypes, "length") > 0) {
          this.visatype = this.activeVisatypes[0];
          this.getvisasubtypes(this.visatype);
        }
      });

      this.setPwdFilled(false);
    },
    migrateToIndividuals() {
      this.$validator.validateAll().then((result) => {
        this.moveToIndidualsErrorMsg = "";
        if (result) {
          let Payload = {
            userId: this.checkProperty(this.selectedIten, "_id"),
            accountSubType: "Beneficiary",
          };
          this.$store
            .dispatch("commonAction", {
              data: Payload,
              path: "/users/migrate-to-individual",
            })
            .then((res) => {
              this.getbeneficiaries();

              this.moveToIndiduals = false;
              this.showToster({ message: res.message, isError: false });
            })
            .catch((error) => {
              this.formerrors.msg = error;
              //this.showToster({message:error,isError:true });
              this.selectedUser = null;
            });
        }
      });
    },
    openMoveToIndiduals(action = false, selectedItem = null) {
      this.$validator.reset();
      this.selectedIten = selectedItem;
      this.moveToIndiduals = action;

      this.moveToIndidualsErrorMsg = "";
    },
    openInviteToCreateAccount(action = false, selectedItem = null) {
      this.inviteBeneficiary = action;
      this.AddBeneficiary = action;

      this.$validator.reset();
      this.selectedIten = selectedItem;
    },
    editMe(action = false, selectedItem = null) {
      this.selectedIten = selectedItem;
      if (this.checkProperty(this.selectedIten, "_id")) {
        let routeId = this.checkProperty(this.selectedIten, "_id");
        this.$router.push({
          name: "beneficiary-edit",
          params: { itemId: routeId },
        });
      }
    },
    showSetPassword(action = false, selectedItem = null) {
      this.newPassword = "";
      this.confPassword = "";
      this.$validator.reset();
      this.selectedIten = selectedItem;

      this.setPassword = action;

      this.setPasswordErrorMsg = "";
    },

    changePassword() {
      this.$validator.validateAll().then((result) => {
        this.setPasswordErrorMsg = "";
        if (result) {
          let self = this;
          let postData = {
            newPassword: self.newPassword,
            currentPassword: self.confPassword,
            userId: self.selectedIten["_id"],
            //email: this.loginUserData.email,
            // roleId: this.loginRoleId,
          };
          ///auth/change-password,
          this.updatingPassword = true;
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/auth/change-password",
            })
            .then((response) => {
              this.showToster({ message: response.message, isError: false });

              // this.$vs.notify({ text: response.data.message, });
              this.setPassword = false;
              this.formerrors.msg = null;
              this.updatingPassword = false;
            })
            .catch((error) => {
              this.setPasswordErrorMsg = error;
              this.updatingPassword = false;
            });
        }
      });
    },

    resend(item) {
      if (this.getUserRoleId==12) return 
      this.cleanupOldRequests();
      const email = this.checkProperty(item, 'email');
      const userLogs = this.requestLog.filter(log => log.email === email);

      if (userLogs.length >= 3) {
        this.showToster({
          message: 'You’ve reached the limit for resending the link. Please try again later.',
          isError: true
        });
        return;
      }

      let obj = {
        email,
        tenantId: this.checkProperty(this.loginUserData, 'tenantDetails', '_id'),
        eventType: 'Resend Invite',
        actorId: this.checkProperty(this.getUserData, 'userId')
      };
      this.$store
        .dispatch("resend", obj)
        .then((response) => {
          //alert(JSON.stringify(response.data.message))
          if (response.error) {
            this.showToster({ message: response.error.message, isError: true });
          } else {
            this.requestLog.push({ email, timestamp: Date.now() });
            this.saveState();
            this.startCountdown(email, 60);
            this.showToster({ message: response.data.message, isError: false });
          }
        })
        .catch((err) => {
          this.showToster({ message: err, isError: true });
        });
    },
    openAddpetPopUp() {
      this.newPetOpenFromben = true;
      this.selectedPetitioner = null;
      this.invitepetitioner = true;
    },
    closenewPetPopup(selectedPetitioner = null) {
      this.getPetitioners();
      this.selectedPetitioner = selectedPetitioner;
      this.invitePetitionPopupshow(false);

      if (this.checkProperty(this.selectedPetitioner, "userId")) {
        this.openNewbenFormPopup(true);
      } else {
        this.openNewbenFormPopup(false);
      }
    },
    upDateBenef() {
      if (
        this.checkProperty(this.selectedBeneficiary, "name") &&
        this.checkProperty(this.selectedBeneficiary, "_id")
      ) {
        this.selectedUser = this.checkProperty(this.selectedBeneficiary, "_id");
        this.selectedUsername = this.checkProperty(
          this.selectedBeneficiary,
          "name"
        );
      }
      if (
        !this.checkProperty(this.selectedBeneficiary, "email") &&
        this.checkProperty(this.selectedBeneficiary, "tempUser") == true
      ) {
        this.hideBeneforQues = false;
        this.fillTheQuestionnire = "Petitioner";
      } else {
        this.hideBeneforQues = true;
        this.fillTheQuestionnire = "";
      }
      this.getBenficiaryH1BCases();
    },
    closeAddBenPopUp(selectedBeneficiary = null) {
      this.newPetOpenFromben = false;
      this.AddBeneficiary = false;
      this.selectedBeneficiary = selectedBeneficiary;
      if (
        this.checkProperty(this.selectedBeneficiary, "name") &&
        this.checkProperty(this.selectedBeneficiary, "_id")
      ) {
        this.selectedUser = this.checkProperty(this.selectedBeneficiary, "_id");
        this.selectedUsername = this.checkProperty(
          this.selectedBeneficiary,
          "name"
        );
      }
      this.AddBeneficiary = false;
      this.getBenficiaryH1BCases();
      this.getbeneficiaries();
    },
    opneDetails(tr) {
      let itId = tr;
      this.$router
        .push({
          path: `/beneficiaries-details/${itId["_id"]}`,
          query: { filter: this.encodedString },
        })
        .catch((err) => {});
      //this.$router.push("/beneficiaries-details/"+tr['_id'])
    },
    petitionerUpdated() {
      this.selectedBeneficiary = null;
      this.selectedUser = "";
      this.selectedUsername = "";
      this.getbeneficiaryMasterDataList();
      this.getBenficiaryH1BCases();
    },
    getbeneficiaryMasterDataList(text = "") {
      let postData = {
        matcher: {
          title: text,
          statusList: [],
          branchIds: [],
          companyIds: [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          createdByIds: [],
          createdDateRange: [],
          roleIds: [51],
          statusIds: [],
          petitionTypeIds: [],
          petitionSubTypeIds: [],
          petitionCreatedDateRange: [],
          petitionStatusIds: [],
          getPetitionStats: true,
        },
        sorting: {
          path: "lastName", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          order: 1,
        },
        page: 1,
        perpage: 1000000,
        getMasterData: true,
        getBeneficiaryList: true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        branchId: "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        companyId: "", // Required when 'getMasterData' is true and roleIds are [50, 51]
      };
      this.enableAddNewBenTag = false;
      if (this.checkProperty(this.selectedPetitioner, "_id")) {
        postData["companyId"] = this.selectedPetitioner["_id"];
      } else if (
        [12, 48, 50, 51].indexOf(this.getUserRoleId) > -1 &&
        this.checkProperty(this.getUserData, "companyDetails", "_id")
      ) {
        postData["companyId"] = this.checkProperty(
          this.getUserData,
          "companyDetails",
          "_id"
        );
      } else {
        postData["matcher"]["accountType"] = "Individual";
      }
      //this.beneficiaryMasterDataList =[];
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then((response) => {
          this.beneficiaryMasterDataList = response.list;

          let filteredData = [];
          _.forEach(this.beneficiaryMasterDataList, (item) => {
            if (item && (_.has(item, "name") || _.has(item, "email"))) {
              if (
                (_.has(item, "name") && item["name"].includes(text)) ||
                (_.has(item, "email") && item["email"].includes(text))
              ) {
                filteredData.push(item);
              } else {
                return false;
              }
            } else {
              return false;
            }
          });

          if (filteredData.length <= 0) {
            this.enableAddNewBenTag = true;
          }
        });
    },

    addNewBenFromTag(newBen = "") {
      this.beneficiary["email"] = newBen;
      this.invitePetitionPopupshow(false);
      this.openNewbenFormPopup(true);
    },

    searchPet(searchText) {
      let _self = this;

      this.enableAddNewpet = false;
      this.selectedBeneficiary = null;
      this.selectedPetitioner = null;
      this.selectedUser = "";
      this.selectedUsername = "";
      this.newPetitioner.email = searchText;
      let filteredData = [];
      _.forEach(_self.petitionersList, (item) => {
        if (item && (_.has(item, "name") || _.has(item, "email"))) {
          if (
            (_.has(item, "name") && item["name"].includes(searchText)) ||
            (_.has(item, "email") && item["email"].includes(searchText))
          ) {
            filteredData.push(item);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      if (filteredData.length <= 0) {
        //this.enableAddNewpet =true;
        // this   this.addNewPete = true;
        this.getPetitioners(true, searchText);
      }
    },
    addNewPet(newPet = "", id) {
      this.newPetOpenFromben = false;
      this.openNewbenForm = false;
      this.addNewPete = true;
      this.invitePetitionPopupshow(true);
    },

    updatePetitionerPhone(item) {
      this.isPetitionerPhoneValid = true;
      if (item.isValid) {
        this.newPetitioner.phoneCountryCode = {
          countryCode: item.countryCode,
          countryCallingCode: item.countryCallingCode,
        };
        this.newPetitioner.phone = item.nationalNumber;

        Object.assign(this.formerrors, { msg: "" });
        this.selectedPwdId = null;
        this.isLinkPwd = false;
        this.isPwdFiled = false;
        if (this.visatype && _.has(this.visatype, "id")) {
          this.visasubtypes = [];
          this.visasubtype = null;

          let item = {
            matcher: {
              // "searchString":this.searchtxt,
              petitionType: parseInt(this.visatype["id"]),
              getActiveList: true,
            },
            page: 1,
            perpage: this.perpage,
            category: "petition_sub_types",
          };

          this.$store.dispatch("getMasterData", item).then((response) => {
            this.visasubtypes = response.list;
            // if(response['list']){
            //   this.visasubtypes = _.filter(response['list'] ,(item)=>{
            //  return item.id !=15
            // })
            // }
            if (
              parseInt(this.visatype["id"]) == 2 &&
              this.checkProperty(this.visasubtypes, "length") > 0
            ) {
              this.visasubtype = this.visasubtypes[0];
            }
          });
          this.$validator.reset();
        } else {
          this.isPetitionerPhoneValid = false;
        }
      }
    },
    openNewbenFormPopup(action = false) {
      this.saveBenbtn = false;
      if (action == true) {
        this.invitePetitionPopupshow(false);
      }
      if (action) {
        if (this.checkProperty(this.selectedPetitioner, "userId")) {
          this.AddBeneficiary = true;
          try {
            setTimeout(() => {
              this.$refs["add_ben"].setPetDetails(this.selectedPetitioner);
            }, 50);
          } catch (e) {}
        } else {
          this.$validator.validateAll("newpetitionform").then((res) => {});
          this.AddBeneficiary = false;
        }
      } else {
        this.AddBeneficiary = action;
      }

      this.$validator.reset();
    },

    invitePetitionPopupshow(action = true) {
      this.newPetitioner["name"] = "";
      this.newPetitioner["adminFirstName"] = "";
      this.newPetitioner["adminLastName"] = "";
      this.newPetitioner["phoneCountryCode"] = {
        countryCode: "",
        countryCallingCode: "",
      };
      this.newPetitioner["roleId"] = 50;
      this.newPetitioner["phone"] = "";
      this.newPetitioner["invite"] = true;
      this.invitepetitioner = action;
      this.isPetitionerPhoneValid = true;
      this.$validator.reset();
    },

    getPetitioners(callFromSerch = false, searchText = "") {
      this.enableAddNewpet = false;
      let _self = this;
      if (this.callFromSerch) {
        // this.petitionersList =[];
      }
      let query = {
        matcher: {
          searchString: searchText,
          statusIds: [],
          countryIds: [],
          stateIds: [],
          locationIds: [],
          createdDateRange: [],
        },
        sorting: { path: "createdOn", order: 1 },
        page: 1,
        perpage: 100,
        getMasterData: true,
      };

      this.$store
        .dispatch("getList", { data: query, path: "/company/list" })
        .then((response) => {
          _self.petitionersList = response.list;

          let filteredData = _.filter(_self.petitionersList, (item) => {
            if (item && (_.has(item, "name") || _.has(item, "email"))) {
              if (
                (_.has(item, "name") && item["name"].includes(searchText)) ||
                (_.has(item, "email") && item["email"].includes(searchText))
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          });

          if (
            callFromSerch &&
            (!filteredData ||
              (filteredData && filteredData.length <= 0 && !this.editMode))
          ) {
            this.enableAddNewpet = true;
            this.addNewPete = true;
          }

          //alert(this.perpage);
        })
        .catch((err) => {
          this.petitionersList = [];
        });
    },

    gotoDetailsPage(petitionId = "", subType = 0) {
      if (petitionId != "") {
        if ([15].indexOf(subType) > -1) {
          this.$router.push("/gc-employment-details/" + petitionId);
        } else {
          this.$router.push("/petition-details/" + petitionId);
        }
      }
    },
    sortMe(sort_key = "") {
      this.sortKey = {
        path: "lastName", // invitedByName, updatedOn, name, email, phone, statusName, roleName
        order: 1,
      };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        localStorage.setItem("tickets_sort_key", sort_key);
        localStorage.setItem("tickets_sort_value", this.sortKey[sort_key]);

        this.sortKey = {
          path: sort_key,
          order: parseInt(this.sortKeys[sort_key]),
        };
        this.getbeneficiaries();
      }
    },

    changedVsaType(item) {
      this.filteredVisaSubTypes = [];
      this.allsubTyps = [];
      this.filteredVisaType = item;
      if (this.filteredVisaType && _.has(this.filteredVisaType, "id")) {
        this.allsubTyps = [];

        let item = {
          matcher: {
            // "searchString":this.searchtxt,
            petitionType: parseInt(this.filteredVisaType["id"]),
          },
          page: 1,
          perpage: 10000,
          category: "petition_sub_types",
        };

        this.$store.dispatch("getMasterData", item).then((response) => {
          this.allsubTyps = response.list;
        });
      }
    },

    openNewPetitionPopUp(action = false, item = null) {
      this.petiApprovReqPWDDoc = false;
      this.disableOffice = false;
      this.permJobDetails = null;
      this.permDocFormatError = "";
      this.disablePWDstatus = false;
      this.setPwdFilled(false);
      this.isPwdFiled = false;
      this.permDocRequired = false;
      this.permDolDocs = [];
      this.classification = "";
      this.isLinkPwd = false;
      this.selectedPwdId = null;
      this.category = "";
      this.newPetOpenFromben = false;
      this.invitepetitioner = false;
      this.openNewbenForm = false;
      this.selectedPetitioner = null;
      this.selectedBeneficiary = item;
      if (this.checkProperty(this.selectedBeneficiary, "_id")) {
        this.selectedBeneficiaryId = this.checkProperty(
          this.selectedBeneficiary,
          "_id"
        );
      }
      //alert(JSON.stringify(this.selectedBeneficiary))
      if (this.checkProperty(item, "petitionerDetails")) {
        this.selectedPetitioner = item["petitionerDetails"];
        this.getbeneficiaryMasterDataList();
        if (
          this.checkProperty(this.selectedPetitioner, "branchId") &&
          !this.checkProperty(this.selectedPetitioner, "custBranchType") &&
          [3, 12, 48, 50].indexOf(this.getUserRoleId) > -1
        ) {
          let branchDetails = _.find(this.branchList, {
            _id: this.checkProperty(this.selectedPetitioner, "branchId"),
          });
          this.selectedBranch = { name: "", _id: "" };
          this.selectedBranch["name"] = branchDetails["name"];
          this.selectedBranch["_id"] = branchDetails["_id"];
          if (this.selectedBranch["_id"] && this.selectedBranch["name"]) {
            this.disableOffice = true;
          }
        }
      }
      if ([3, 12, 48, 50].indexOf(this.getUserRoleId) <= -1) {
        if (this.checkProperty(this.getUserData, "branchDetails")) {
          let branchDetails = this.checkProperty(
            this.getUserData,
            "branchDetails"
          );
          this.selectedBranch = { name: "", _id: "" };
          this.selectedBranch["name"] = branchDetails["name"];
          this.selectedBranch["_id"] = branchDetails["_id"];
          if (this.selectedBranch["_id"] && this.selectedBranch["name"]) {
            this.disableOffice = true;
          }
        }
      }

      this.getPetitioners(true, "");

      this.visatype = {
        id: 1,
        name: "H-1B",
      };

      this.getvisaforNewCase();
      Object.assign(this.formerrors, {
        msg: "",
      });
      this.newPetitionFormSubmited = false;
      this.NewPetition = action;
      if (this.NewPetition) {
        this.$modal.show("benCaseCreationModal");
      } else {
        this.$modal.hide("benCaseCreationModal");
      }

      this.draftExtractInfo = null;
      this.benficiaryH1BCases = [];
      this.documentUploading = false;
      this.rfeData = {
        rfeIssuedDate: null,
        rfeReceivedDate: null,
        rfeCaseUscisDeadlineDate: null,
        uscisReceiptNumber: "",
        rfeInternalCase: "internalCase", //'externalCase',//'internalCase',
        documents: [],
        docs: {
          copyOfRfe: [],
          orgPetition: [],
          petitionerDocs: [],
          employmentDocs: [],
          beneficiaryDocs: [],
          other: [],
        },
        h1bCaseId: null,
      };

      this.getBenficiaryH1BCases();
      this.$validator.reset();
    },
    addNewBeneficiary() {
      this.newPetOpenFromben = false;
      this.invitepetitioner = false;
      this.openNewbenForm = false;
      this.beneficiary = {
        firstName: "",
        lastName: "",
        name: "",
        email: "",
        phone: "",
        phoneCountryCode: { countryCode: "", countryCallingCode: "" },
      };
      Object.assign(this.formerrors, {
        msg: "",
      });

      this.AddBeneficiary = true;
      this.$validator.reset();
      this.isPhoneValid = true;
      this.saveBenbtn = false;
      this.getPetitioners(true, "");
    },
    getActiveI9CaseOfEmployee(userId) {
      return this.$store
        .dispatch("getActiveI9cases", { userId })
        .then((response) => {
            if (
                response &&
                response.data &&
                Array.isArray(response.data.result) &&
                response.data.result.length > 0
            ) {
                this.i9CaseId = response.data.result[0]._id;
            } else {
                this.i9CaseId = null;
            }
        })
        .catch((error) => {
            this.i9CaseId = null;
        });
    },
    editEmployee(tr) {
      console.log(" selected ee ----------", tr);
      this.getActiveI9CaseOfEmployee(this.checkProperty(tr, '_id'))
      this.selectedIten = tr;
      this.selectedPetitioner = tr.petitionerDetails;
      this.inviteBeneficiary = false;
      this.editMode = true;
      this.newPetOpenFromben = false;
      this.invitepetitioner = false;
      this.openNewbenForm = false;
      this.beneficiary = {
        firstName: this.checkProperty(tr, "firstName"),
        lastName: this.checkProperty(tr, "lastName"),
        name: this.checkProperty(tr, "name"),
        email: this.checkProperty(tr, "email"),
        phone: this.checkProperty(tr, "phone"),
        phoneCountryCode: this.checkProperty(tr, "phoneCountryCode"),
      };
      Object.assign(this.formerrors, {
        msg: "",
      });

      this.AddBeneficiary = true;
      this.$validator.reset();
      this.isPhoneValid = true;
      this.saveBenbtn = false;
      this.getPetitioners(true, "");
    },
    updatePhone(item) {
      this.isPhoneValid = true;
      if (item.isValid) {
        this.beneficiary.phoneCountryCode = {
          countryCode: item.countryCode,
          countryCallingCode: item.countryCallingCode,
        };
        this.beneficiary.phone = item.nationalNumber;
      } else {
        this.isPhoneValid = false;
      }
    },

    getBranchList() {
      this.selectedBranch = null;
      this.branchList = [];
      let postData = {
        filters: {
          title: "",
          createdDateRange: [],
          statusList: [],
          activeList: [],
        },
        getMasterData: true,
        page: 1,
        perpage: 25000,
        sorting: { path: "createdOn", order: -1 },
      };
      this.$store
        .dispatch("getList", { data: postData, path: "/branch/list" })
        .then((response) => {
          this.branchList = response.list;
          if (this.branchList.length == 1) {
            this.selectedBranch = this.branchList[0];
          }
        })
        .catch((error) => {});
    },
    goto(Id) {
      this.$router
        .push({ name: "petition-details", params: { itemId: Id } })
        .catch((err) => {});
    },
    fileNewCase() {
      this.pwdDocFormatError = "";
      if (this.checkProperty(this.visasubtype, "id") == 15) {
        this.createNewPerm();
      } else {
        this.createNewPetition(false);
      }
    },
    createNewPerm() {
      Object.assign(this.formerrors, {
        msg: "",
      });

      this.$validator.validateAll("newpetitionform").then((result) => {
        if (result) {
          let self = this;
          // premiumProcessing:this.premiumProcessing,
          var postdata = {
            type: this.visatype.id,
            userId: this.selectedUser,
            userName: this.selectedUsername,
            typeName: this.visatype.name,
            subType: this.visasubtype.id,
            subTypeName: this.visasubtype.name,
            petitionerId: null,
            branchId: "",
            today: moment().format("YYYY-MM-DD"),
            isPwdFiled: this.isPwdFiled,
            hasJobDetails: this.hasJobDetails,
            petiApprovReqPWDDoc: this.petiApprovReqPWDDoc,
          };
          if (this.getTenantTypeId != 2) {
            if ([48, 50, 12].indexOf(this.loginRoleId) > -1) {
              postdata["petitionerId"] = this.$store.state.user._id;
            } else {
              postdata["petitionerId"] = this.checkProperty(
                this.selectedPetitioner,
                "userId"
              );
            }
          }

          // if(this.checkProperty(this.beneficiaryInfo ,"name") && this.beneficiaryId){
          //   postdata['userId'] = this.beneficiaryId;
          //   postdata['userName'] =this.beneficiaryInfo['name']

          // }

          if (this.selectedBranch && _.has(this.selectedBranch, "_id")) {
            postdata["branchId"] = this.selectedBranch["_id"];
          }
          if (this.isPwdFiled) {
            postdata["isPwdFiled"] = this.isPwdFiled;
            if (!_.has(postdata, "pwdResponse")) {
              postdata = Object.assign(postdata, { pwdResponse: {} });
            }

            if (this.pwdResponse["pwdDocCaseNo"]) {
              postdata["pwdDocCaseNo"] = this.pwdResponse["pwdDocCaseNo"];
            }

            if (this.pwdStatus == "Certified") {
              postdata["pwdResponse"]["documentType"] = "";

              if (this.pwdResponse["issuedDate"]) {
                postdata["pwdResponse"]["issuedDate"] = moment(
                  this.pwdResponse["issuedDate"]
                ).format("YYYY-MM-DD");
              }
              if (this.pwdResponse["receivedDate"]) {
                postdata["pwdResponse"]["receivedDate"] = moment(
                  this.pwdResponse["receivedDate"]
                ).format("YYYY-MM-DD");
              }

              if (this.pwdResponse["dueDate"]) {
                postdata["pwdResponse"]["dueDate"] = moment(
                  this.pwdResponse["dueDate"]
                ).format("YYYY-MM-DD");
              }

              postdata["pwdResponse"]["description"] =
                this.pwdResponse["description"];
            }

            postdata["pwdStatus"] = this.pwdStatus;
            postdata["pwdResponse"]["documents"] =
              this.pwdResponse["documents"];
            postdata["draftExtractInfo"] = this.draftExtractInfo;
          }
          if (this.isLinkPwd && this.checkProperty(this.selectedPwdId, "_id")) {
            postdata["pwdId"] = this.checkProperty(this.selectedPwdId, "_id");
          }
          if (this.hasJobDetails) {
            postdata["hasJobDetails"] = this.hasJobDetails;
            postdata["jobDetails"] = _.cloneDeep(this.jobDetails);
          }
          if (!this.newPetitionFormSubmited) {
            this.newPetitionFormSubmited = true;

            this.$store
              .dispatch("commonAction", {
                data: postdata,
                path: "/perm/create",
              })
              .then((response) => {
                this.premiumProcessing = false;
                if (response.error) {
                  Object.assign(this.formerrors, {
                    msg: response.error.message,
                  });
                  this.newPetitionFormSubmited = false;
                } else {
                  let dt = {
                    petitionId: response._id,
                    userName: this.selectedUsername,
                    email: this.selectedUseremail,
                    typeName: this.visatype.name,
                    subTypeName: this.visasubtype.id,
                    instructions: null,
                  };
                  //   if(this.isLinkPwd  && this.checkProperty(this.selectedPwdId,'_id') && this.checkProperty(response,'caseNo') && this.checkProperty(response,'_id')){
                  //   let obj={
                  //     caseNo:this.checkProperty(response,'caseNo'),
                  //     _id:this.checkProperty(response,'_id'),
                  //   }
                  //   this.linkPwd(obj)
                  // }
                  //this.addNewCase(false);
                  this.NewPetition = false;
                  this.newPetitionFormSubmited = false;
                  this.getPetitioners();
                  //this.$vs.notify({title: "Success",text: response.message });

                  this.visatype = {
                    id: 1,
                    name: "H-1B",
                  };
                  this.getvisasubtypes(this.visatype);
                  this.showToster({
                    message: response.message,
                    isError: false,
                  });
                  this.openNewPetitionPopUp(false);
                  setTimeout(() => {
                    if (
                      self.checkProperty(
                        self.selectedBeneficiary,
                        "anonymousUser"
                      )
                    ) {
                      this.$router
                        .push({
                          name: "gc-employment-details",
                          params: { itemId: response._id },
                        })
                        .catch((err) => {});
                    } else {
                      this.$router
                        .push({
                          name: "gc-employment-details",
                          params: { itemId: response._id },
                        })
                        .catch((err) => {});
                      // this.clear_filter();
                    }
                  }, 10);
                }
              })
              .catch((error) => {
                //this.showToster({message:error,isError:true});
                this.newPetitionFormSubmited = false;

                Object.assign(this.formerrors, {
                  msg: error,
                });
              });
          }
        } else {
          const $ = JQuery;
          if ($(".errorScroll .text-danger:visible")) {
            var _t = $(".errorScroll .text-danger:visible")
              .first()
              .parent()
              .offset().top;

            if (_t < 0) _t = -_t;

            $(".scrollable:visible").scrollTop(_t - 50);
          }
        }
      });
    },
    linkPwd(val) {
      let self = this;
      let postData = {
        caseNo: val["caseNo"],
        petitionIds: [val["_id"]],
        comments: "",
        pwdId: self.checkProperty(self.selectedPwdId, "_id"),
      };
      let path = "/pwd/manage-pwd-linking";
      this.$store
        .dispatch("commonAction", { data: postData, path: path })
        .then((response) => {
          this.showToster({ message: response.message, isError: false });
        })
        .catch((error) => {});
    },
    createNewPetition(callFromConform = false) {
      Object.assign(this.formerrors, {
        msg: "",
      });

      this.$validator.validateAll("newpetitionform").then((result) => {
        if (result) {
          if (
            this.checkProperty(this.visasubtype, "id") == 16 &&
            !callFromConform
          ) {
            this.classificationfun();
            this.newPetitionFormSubmited = true;
            return false;
          }
          let self = this;
          var postdata = {
            type: this.visatype.id,
            userId: this.selectedUser,
            userName: this.selectedUsername,
            typeName: this.checkProperty(this.visatype, "name"),
            subType: this.checkProperty(this.visasubtype, "id"),
            subTypeName: this.checkProperty(this.visasubtype, "name"),
            premiumProcessing: false,
            petitionerId: null,
            branchId: "",
            today: moment().format("YYYY-MM-DD"),
          };

          //h4 case sub types
          if (this.checkProperty(this.visatype, "id") == 2) {
            // postdata['subType'] = 12;
            // postdata['subTypeName'] = '';
          }
          //h4 Ead  sub types
          if (this.checkProperty(this.visatype, "id") == 10) {
            //   postdata['subType'] = 13;
            //  postdata['subTypeName'] = '';
          }

          if (this.checkProperty(this.visatype, "id") != 2) {
            postdata["premiumProcessing"] = this.premiumProcessing;
          }
          if (
            this.checkProperty(this.visatype, "id") == 3 &&
            this.checkProperty(this.visasubtype, "id") == 16 &&
            this.checkProperty(this.permDolDocs, "length") > 0 &&
            this.classification != ""
          ) {
            postdata["classification"] = this.classification;
            postdata["categoryId"] = this.checkProperty(this.category, "id");
            postdata["permId"] = this.responsePermId;
            postdata["i140PriorityDate"] = this.i140PriorityDate;
            postdata["permExpiryDate"] = this.permExpiryDate;

            if (this.permDocRequired) {
              postdata["jobDetails"] = _.cloneDeep(this.permDetails);

              postdata["draftExtractInfo"] = this.draftExtractInfo;
              if (this.checkProperty(this.permDetails, "i140PriorityDate")) {
                postdata["i140PriorityDate"] = this.checkProperty(
                  this.permDetails,
                  "i140PriorityDate"
                );
              }
              if (this.checkProperty(this.permDetails, "expiryDate")) {
                postdata["permExpiryDate"] = this.checkProperty(
                  this.permDetails,
                  "expiryDate"
                );
              }
            }
            postdata["permDocs"] = this.permDolDocs;
          }
          if (
            this.checkProperty(this.visatype, "id") == 3 &&
            this.checkProperty(this.visasubtype, "id") == 17 &&
            this.checkProperty(this.Dol140Docs, "length") > 0
          ) {
            postdata["i140Id"] = this.response140Id;
            postdata["i140Docs"] = this.Dol140Docs;
          }
          if (this.getTenantTypeId != 2) {
            if ([48, 50, 12].indexOf(this.loginRoleId) > -1) {
              postdata["petitionerId"] = this.$store.state.user._id;
            } else {
              postdata["petitionerId"] = this.checkProperty(
                this.selectedPetitioner,
                "userId"
              );
            }
          }
          if (
            this.getTenantTypeId != 2 &&
            this.checkProperty(this.visatype, "id") == 4 &&
            this.checkProperty(this.visasubtype, "id") == 18
          ) {
            postdata["petitionerId"] = this.checkProperty(this.sponsor, "_id");
            postdata["fillTheQuestionnire"] = this.fillTheQuestionnire;
          }
          if (this.checkProperty(this.visatype, "id") == 5) {
            postdata["fillTheQuestionnire"] = this.fillTheQuestionnire;
          }

          if (this.selectedBranch && _.has(this.selectedBranch, "_id")) {
            postdata["branchId"] = this.selectedBranch["_id"];
          }

          //rfe case creation
          if (this.checkProperty(this.visatype, "id") == 9) {
            postdata["premiumProcessing"] = false;

            postdata["rfeIntExtOption"] =
              this.checkProperty(this.rfeData, "rfeInternalCase") ==
              "internalCase"
                ? "internal"
                : "filed_separately";
            postdata["documents"] = this.rfeData["docs"];
            if (
              this.checkProperty(this.rfeData, "rfeInternalCase") ==
              "internalCase"
            ) {
              postdata["h1bCaseId"] = this.checkProperty(
                this.rfeData,
                "h1bCaseId",
                "_id"
              );
              if (
                this.checkProperty(this.rfeData, "rfeCaseUscisDeadlineDate")
              ) {
                postdata["rfeDueDate"] = moment(
                  this.rfeData["rfeCaseUscisDeadlineDate"]
                ).format("YYYY-MM-DD");
              }
            } else {
              if (
                this.checkProperty(this.rfeData, "rfeCaseUscisDeadlineDate")
              ) {
                postdata["rfeDueDate"] = moment(
                  this.rfeData["rfeCaseUscisDeadlineDate"]
                ).format("YYYY-MM-DD");
              }
              if (this.draftExtractInfo) {
                postdata["draftExtractInfo"] = this.draftExtractInfo;
              }
              postdata["uscisReceiptNumber"] = this.checkProperty(
                this.rfeData,
                "uscisReceiptNumber"
              );
              postdata["rfeIssuedDate"] = this.checkProperty(
                this.rfeData,
                "rfeIssuedDate"
              );
              postdata["rfeReceivedDate"] = this.checkProperty(
                this.rfeData,
                "rfeReceivedDate"
              );

              if (
                this.checkProperty(this.rfeData, "documents", "length") > 0 &&
                this.checkProperty(this.rfeData, "rfeInternalCase") !=
                  "internalCase"
              ) {
                postdata["documents"]["copyOfRfe"] = this.rfeData["documents"];
              }
            }
          }

          if (!this.newPetitionFormSubmited) {
            this.newPetitionFormSubmited = true;
            this.$store
              .dispatch("petitioner/createnewpetition", postdata)
              .then((response) => {
                this.premiumProcessing = false;
                if (response.error) {
                  Object.assign(this.formerrors, {
                    msg: response.error.message,
                  });
                  this.newPetitionFormSubmited = false;
                } else {
                  let dt = {
                    petitionId: response._id,
                    userName: this.selectedUsername,
                    email: this.selectedUseremail,
                    typeName: this.visatype.name,
                    subTypeName: this.checkProperty(this.visasubtype, "name"),
                    instructions: null,
                  };
                  this.$store
                    .dispatch("petitioner/sendquestionnaire", dt)
                    .then((response) => {});
                  this.NewPetition = false;
                  //this.$vs.notify({title: "Success",text: response.message });
                  this.showToster({
                    message: response.message,
                    isError: false,
                  });
                  this.openNewPetitionPopUp(false);
                  setTimeout(() => {
                    if (
                      self.checkProperty(
                        self.selectedBeneficiary,
                        "anonymousUser"
                      )
                    ) {
                      self.goto(response._id);
                    } else {
                      self.goto(response._id);
                      // this.getbeneficiaries();
                    }
                  }, 50);
                }
              })
              .catch((error) => {
                //this.showToster({message:error,isError:true});
                this.newPetitionFormSubmited = false;

                Object.assign(this.formerrors, {
                  msg: error.message,
                });
              });
          }
        } else {
          const $ = JQuery;
          if ($(".errorScroll .text-danger:visible")) {
            var _t = $(".errorScroll .text-danger:visible")
              .first()
              .parent()
              .offset().top;

            if (_t < 0) _t = -_t;

            $(".scrollable:visible").scrollTop(_t - 50);
          }
        }
      });
    },
    getbeneficiaries(callFromSerch = false) {
      this.callFromSerch = callFromSerch;

      if (this.callFromSerch) {
        this.users = [];
      }

      let postData = {
        matcher: {
          roleIds: [51],
          title: this.searchtxt,
          searchString: this.searchtxt,
          statusIds: this.final_selected_statusids,
          petitionTypeIds: [],
          petitionSubTypeIds: [],
          petitionSearchString: "",
          petitionCreatedDateRange: [],
          petitionStatusIds: [],
          getPetitionStats: true,
          // "beneficiaryType": "beneficiary-list", // beneficiary or individual-list or beneficiary-list,
          companyIds: [],
          createdDateRange: [],
        },
        showInvalidated: this.showInvalidated,
        sorting: this.sortKey,
        page: this.page,
        perpage: this.perpage,
        getBeneficiaryList: false,
      };

        if([2,3].indexOf(this.isActiveListSelected.id) > -1){
          postData["matcher"]['activated'] = this.isActiveListSelected.id === 2;
        }
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        postData["matcher"]["petitionCreatedDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }
      if (
        this.selected_normcreatedDateRange["startDate"] &&
        this.selected_normcreatedDateRange["startDate"] != "" &&
        this.selected_normcreatedDateRange["endDate"] != "" &&
        this.selected_normcreatedDateRange["endDate"]
      ) {
        postData["matcher"]["createdDateRange"] = [
          this.selected_normcreatedDateRange["startDate"],
          this.selected_normcreatedDateRange["endDate"],
        ];
      }
      if (
        this.selected_hireDateRange["startDate"] &&
        this.selected_hireDateRange["startDate"] != "" &&
        this.selected_hireDateRange["endDate"] != "" &&
        this.selected_hireDateRange["endDate"]
      ) {
        postData["matcher"]["hireDateRange"] = [
          this.selected_hireDateRange["startDate"],
          this.selected_hireDateRange["endDate"],
        ];
      }
      if (
        this.selected_terminationdate["startDate"] &&
        this.selected_terminationdate["startDate"] != "" &&
        this.selected_terminationdate["endDate"] != "" &&
        this.selected_terminationdate["endDate"]
      ) {
        postData["matcher"]["terminatedDateRange"] = [
          this.selected_terminationdate["startDate"],
          this.selected_terminationdate["endDate"],
        ];
      }
      /*
        this.filteredVisaType =null;
        this.filteredVisaSubTypes = [] ; filteredVisaSubTypes
        */
      if (this.filteredVisaType && _.has(this.filteredVisaType, "id")) {
        postData["matcher"]["petitionTypeIds"] = [this.filteredVisaType["id"]];
      }

      if (this.filteredVisaSubTypes && this.filteredVisaSubTypes.length > 0) {
        postData["matcher"]["petitionSubTypeIds"] =
          this.filteredVisaSubTypes.map((item) => {
            return item["id"];
          });
      }
      if (
        this.selectedPetitionerforFilter &&
        this.selectedPetitionerforFilter.length > 0
      ) {
        postData["matcher"]["companyIds"] =
          this.selectedPetitionerforFilter.map((item) => {
            return item["_id"];
          });
      }
      postData["getBeneficiaryList"] = true;
      let tempObj = {
        selectedPetitionerforFilter: this.selectedPetitionerforFilter,
        filteredVisaSubTypes: this.filteredVisaSubTypes,
        filteredVisaType: this.filteredVisaType,
        selected_statusids: this.selected_statusids,
        searchtxt: this.searchtxt,
        sortKey: this.sortKey,
        page: this.page,
        perpage: this.perpage,
      };
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        tempObj["petitionstartDate"] =
          this.selected_createdDateRange["startDate"];
        tempObj["petitionendDate"] = this.selected_createdDateRange["endDate"];
      }
      if (
        this.selected_normcreatedDateRange["startDate"] &&
        this.selected_normcreatedDateRange["startDate"] != "" &&
        this.selected_normcreatedDateRange["endDate"] != "" &&
        this.selected_normcreatedDateRange["endDate"]
      ) {
        tempObj["normalstartDate"] =
          this.selected_normcreatedDateRange["startDate"];
        tempObj["normalendDate"] =
          this.selected_normcreatedDateRange["endDate"];
      }
       if (
        this.selected_terminationdate["startDate"] &&
        this.selected_terminationdate["startDate"] != "" &&
        this.selected_terminationdate["endDate"] != "" &&
        this.selected_terminationdate["endDate"]
      ) {
        tempObj["termstartDate"] =
          this.selected_terminationdate["startDate"];
        tempObj["termendDate"] =
          this.selected_terminationdate["endDate"];
      }
      this.setQueryString(tempObj);

      this.isListloading = true;
      this.updateLoading(true);
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then((response) => {
          let tempList = response.list;
          let isTerminationDate = false;
          _.forEach(tempList, (user) => {
            if(this.checkProperty(user, 'terminatedOn')){
              isTerminationDate = true
            }
            user = Object.assign(user, { isTempAccount: false });
            if (_.has(user, "email")) {
              let parts = user.email.split("@");
              if (this.checkProperty(parts, "length") > 0) {
                let domain = parts[parts.length - 1];
                if (["temp-account.com"].indexOf(domain) > -1) {
                  user["isTempAccount"] = true;
                }
              }
            }
          });
          if(isTerminationDate){
            this.enableCol('TD', false)
          }
          this.users = _.cloneDeep(tempList);
          if([12,48,50].indexOf(this.getUserRoleId)>-1 && !this.isTdSelected){
            this.isTdSelected = this.users.some(item=>!!item.terminatedOn)
          }
          this.totalCount = this.checkProperty(response, "totalCount");
          if(this.showFilterCount){
             this.$store.commit('common/setTotalCount',  this.totalCount)
          }else{
            this.$store.commit('common/setTotalCount',  null)
          }
         
          this.totalpages = Math.ceil(response.totalCount / this.perpage);

          this.isListloading = false;
          this.updateLoading(false);
          setTimeout(() => {
            this.updateLoading(false);
          }, 10);
        })
        .catch((err) => {
          this.users = [];
          this.isListLoading = false;
          this.updateLoading(false);
          setTimeout(() => {
            this.updateLoading(false);
          }, 10);
        });
    },
    filterQueryPreSelect(callFromMounted = false) {
      if (this.checkProperty(this.$route, "query", "filter")) {
        try {
          let filter = this.$route["query"]["filter"];
          this.checkProperty(this.$route, "query", "filter");
          var actual = JSON.parse(atob(filter));
          let keys = Object.keys(actual);

          if (_.has(actual, "matcher")) {
            let item = actual["matcher"];
            if (Object.keys(item).length > 0) {
              //final_selected_statusids
              if (
                _.has(item, "statusIds") &&
                this.checkProperty(item, "statusIds", "length") > 0
              ) {
                this.final_selected_statusids = item["statusIds"];
              }
            }
            this.getbeneficiaries(false);
          } else if (this.checkProperty(keys, "length") > 0) {
            if (_.has(actual, "page") && this.checkProperty(actual, "page")) {
              this.page = this.checkProperty(actual, "page");
            }
            if (
              _.has(actual, "perpage") &&
              this.checkProperty(actual, "perpage")
            ) {
              this.perpage = this.checkProperty(actual, "perpage");
            }
            if (
              _.has(actual, "sortKey") &&
              this.checkProperty(actual, "sortKey")
            ) {
              this.sortKey = this.checkProperty(actual, "sortKey");
              if (this.sortKeys) {
                this.sortKeys[actual["sortKey"]["path"]] =
                  actual["sortKey"]["order"];
              }
            }
            if (
              _.has(actual, "selectedPetitionerforFilter") &&
              this.checkProperty(actual, "selectedPetitionerforFilter") &&
              this.checkProperty(
                actual,
                "selectedPetitionerforFilter",
                "length"
              ) > 0
            ) {
              this.selectedPetitionerforFilter = this.checkProperty(
                actual,
                "selectedPetitionerforFilter"
              );
            }
            if (
              _.has(actual, "filteredVisaSubTypes") &&
              this.checkProperty(actual, "filteredVisaSubTypes") &&
              this.checkProperty(actual, "filteredVisaSubTypes", "length") > 0
            ) {
              this.filteredVisaSubTypes = this.checkProperty(
                actual,
                "filteredVisaSubTypes"
              );
            }
            if (
              _.has(actual, "filteredVisaType") &&
              this.checkProperty(actual, "filteredVisaType")
            ) {
              this.filteredVisaType = this.checkProperty(
                actual,
                "filteredVisaType"
              );
            }
            if (
              _.has(actual, "endDate") &&
              this.checkProperty(actual, "endDate")
            ) {
              this.selected_createdDateRange["endDate"] = this.checkProperty(
                actual,
                "endDate"
              );
            }
            if (
              _.has(actual, "searchtxt") &&
              this.checkProperty(actual, "searchtxt")
            ) {
              this.searchtxt = this.checkProperty(actual, "searchtxt");
            }
            if (
              _.has(actual, "selected_statusids") &&
              this.checkProperty(actual, "selected_statusids") &&
              this.checkProperty(actual, "selected_statusids", "length") > 0
            ) {
              this.selected_statusids = this.checkProperty(
                actual,
                "selected_statusids"
              );
            }
            if (
              _.has(actual, "petitionstartDate") &&
              this.checkProperty(actual, "petitionstartDate")
            ) {
              this.selected_createdDateRange["startDate"] = this.checkProperty(
                actual,
                "petitionstartDate"
              );
            }
            if (
              _.has(actual, "petitionendDate") &&
              this.checkProperty(actual, "petitionendDate")
            ) {
              this.selected_createdDateRange["endDate"] = this.checkProperty(
                actual,
                "petitionendDate"
              );
            }
            if (
              _.has(actual, "normalstartDate") &&
              this.checkProperty(actual, "normalstartDate")
            ) {
              this.selected_normcreatedDateRange["startDate"] =
                this.checkProperty(actual, "normalstartDate");
            }
             if (
              _.has(actual, "termstartDate") &&
              this.checkProperty(actual, "termstartDate")
            ) {
              this.selected_terminationdate["startDate"] =
                this.checkProperty(actual, "termstartDate");
            }
            if (
              _.has(actual, "normalendDate") &&
              this.checkProperty(actual, "normalendDate")
            ) {
              this.selected_normcreatedDateRange["endDate"] =
                this.checkProperty(actual, "normalendDate");
            }
             if (
              _.has(actual, "termendDate") &&
              this.checkProperty(actual, "termendDate")
            ) {
              this.selected_terminationdate["endDate"] =
                this.checkProperty(actual, "termendDate");
            }
            this.set_filter();
          } else {
            this.set_filter();
          }
        } catch (e) {
          if (callFromMounted) {
            this.set_filter();
          }
        }
      } else {
        this.set_filter();
      }
    },
    setQueryString(obj) {
      const string = JSON.stringify(obj); // convert Object to a String
      this.encodedString = btoa(string); // Base64 encode the String
      this.$route["query"]["filter"] = this.encodedString;
    },
    savebeneficiary() {
      this.$validator.validateAll().then((result) => {
        this.saveBenbtn = false;
        if (result) {
          let self = this;
          this.beneficiary = Object.assign(this.beneficiary, { roleId: 51 });
          this.beneficiary["name"] =
            this.beneficiary["firstName"].trim() +
            " " +
            this.beneficiary["lastName"].trim();
          this.beneficiary["firstName"] = this.beneficiary["firstName"].trim();
          this.beneficiary["lastName"] = this.beneficiary["lastName"].trim();
          this.beneficiary["name"] = this.beneficiary["name"].trim();
          this.saveBenbtn = true;
          let postData = this.beneficiary;
          if (
            self.selectedPetitioner &&
            _.has(self.selectedPetitioner, "_id")
          ) {
            postData = Object.assign(postData, {
              companyId: self.selectedPetitioner["_id"],
            });
          }
          this.$store
            .dispatch("beneficiaryregister", postData)
            .then((response) => {
              this.saveBenbtn = false;
              if (response.error) {
                Object.assign(this.formerrors, {
                  msg: response.error.message,
                });
              } else {
                this.AddBeneficiary = false;
                this.selectedBeneficiary = response.data["result"];
                this.showToster({
                  message: response.data.message,
                  isError: false,
                });
                this.openNewbenForm = false;
                // this.$router.go("/beneficiaries");
                this.getbeneficiaries();
              }

              // this.$router.go('/beneficiaries');
            })
            .catch((err) => {
              this.saveBenbtn = false;
              //this.showToster({message:err,isError:true })
              Object.assign(this.formerrors, {
                msg: err,
              });
            });
        }
      });
    },

    get_statusids() {
      let postData = {
        page: 1,
        perpage: 10000,
        category: "employee_status",
        // tenantId: "5db7d79d6032453bd060ed9c",
      };

      this.$store.dispatch("getMasterData", postData).then((response) => {
        //   this.all_statusids =  _.filter(response.list,function(i){
        //     return i['id']!=1;
        // });
       this.all_statusids = [
      { name: "Select all / Deselect all", id: "all", isSelected:false },
      ...response.list
    ];
      });
    },

    //get all_states
    get_all_states() {
      this.$store
        .dispatch("getstates", this.filtered_country)
        .then((response) => {
          this.all_states = response;
        });
    },
    getvisatypes() {
      this.$store.dispatch("getvisatypes").then((response) => {
        this.visatypes = response;
      });
    },
    getvisasubtypes(vsType) {
      Object.assign(this.formerrors, { msg: "" });
      this.selectedPwdId = null;
      this.isLinkPwd = false;
      this.isPwdFiled = false;
      if (this.visatype && _.has(this.visatype, "id")) {
        this.visasubtypes = [];
        this.visasubtype = null;

        let item = {
          matcher: {
            // "searchString":this.searchtxt,
            petitionType: parseInt(this.visatype["id"]),
            getActiveList: true,
          },
          page: 1,
          perpage: this.perpage,
          category: "petition_sub_types",
        };

        this.$store.dispatch("getMasterData", item).then((response) => {
          this.visasubtypes = response.list;
          // if(response['list']){
          //   this.visasubtypes = _.filter(response['list'] ,(item)=>{
          //  return item.id !=15
          // })
          // }
        });
        this.$validator.reset();
      }

      if (this.checkProperty(this.visatype, "id") == 9) {
        this.getBenficiaryH1BCases();
      } else {
        this.resetRfeData(true);
      }
      this.$validator.reset();
    },
    getAllLocations() {
      Object.assign(this.query, {
        countryId: this.filtered_country,
        stateId: this.singel_final_selected_state, //this.final_selected_states //3922
      });

      this.$store.dispatch("getlocations", this.query).then((response) => {
        this.all_locations = response;
      });
    },
    changedState() {
      this.singel_final_selected_state = "";
      this.final_selected_locations = [];
      this.singel_final_selected_state = this.seleted_states["id"];
      this.final_selected_states.push(this.seleted_states["id"]);
      this.getAllLocations();
    },
    multiple_changedState: function () {
      if (this.seleted_states.length > 0) {
        this.final_selected_states = [];
        for (let ind = 0; ind < this.seleted_states.length; ind++) {
          let current_index = this.seleted_states[ind];
          this.final_selected_states.push(current_index["id"]);
        }
        this.getAllLocations();
      } else {
        this.final_selected_states = [];
        this.final_selected_locations = [];
      }
    },
    set_filter: function () {
      this.final_selected_statusids = [];
      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      //states
      this.final_selected_states = [];
      if (this.seleted_states.length > 0) {
        this.final_selected_states = [];
        for (let ind = 0; ind < this.seleted_states.length; ind++) {
          let current_index = this.seleted_states[ind];
          this.final_selected_states.push(current_index["id"]);
        }
      }

      this.final_selected_locations = [];
      if (this.seleted_locations.length > 0) {
        for (let ind = 0; ind < this.seleted_locations.length; ind++) {
          let current_index = this.seleted_locations[ind];
          this.final_selected_locations.push(current_index["id"]);
        }
      }
      this.page = 1;
      this.getbeneficiaries(true);
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove("scroll-hidden");
    },
    clear_filter: function () {
      this.searchtxt = "";
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.seleted_states = [];
      this.final_selected_states = [];
      this.singel_final_selected_state = "";
      this.seleted_locations = [];
      this.final_selected_locations = [];
      this.date = "";
      this.date_range = [];
      this.selected_country_obj = "";

      this.selected_createdDateRange["startDate"] = null;
      this.selected_createdDateRange["endDate"] = null;
      this.selected_createdDateRange = [];
      this.selected_normcreatedDateRange["startDate"] = null;
      this.selected_normcreatedDateRange["endDate"] = null;
      this.selected_hireDateRange["startDate"] = null;
      this.selected_hireDateRange["endDate"] = null;
      this.selected_normcreatedDateRange = [];
      this.selected_hireDateRange = [];
      this.selected_terminationdate["startDate"] = null;
      this.selected_terminationdate["endDate"] = null;
      this.selected_terminationdate = [];
      this.filtered_country = "";
      this.filteredVisaType = null;
      this.filteredVisaSubTypes = [];
      this.selectedPetitionerforFilter = [];
      this.isInvalidateSelected=false
      this.page = 1;
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove("scroll-hidden");
      this.$router.replace({ query: null });
      this.showFilterCount=false
      this.getbeneficiaries();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getbeneficiaries(true);
    },
    selectCreatedDateRange(option) {
      option.startDate = moment(option.startDate).format("YYYY-MM-DD");
      option.endDate = moment(option.endDate).format("YYYY-MM-DD");
      this.selected_createdDateRange = [option.startDate, option.endDate];
    },

    changedCountry() {
      this.filtered_country = this.selected_country_obj["id"];
      this.get_all_states();
    },
  },
  created() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('resendActivationLinkTimer_')) {
        const email = key.replace('resendActivationLinkTimer_', '');
        const expiry = Number(localStorage.getItem(key));
        const diff = Math.floor((expiry - Date.now()) / 1000);

        if (diff > 0) {
          this.startCountdown(email, diff);
        } else {
          localStorage.removeItem(key);
        }
      }
    });
  },
  beforeDestroy() {
    if (this.timers) {
      Object.keys(this.timers).forEach(key => {
        clearInterval(this.timers[key]);
      });
      this.timers = {};
    }

    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
    }
  },
  mounted() {
    this.cleanupInterval = setInterval(() => {
      this.cleanupOldRequests();
    }, 2000); 
    this.isActiveListSelected = this.filters_list[0]
    if([12,48,50].indexOf(this.getUserRoleId)>-1){
      this.getSelectedColms()
    }
    this.getEducationList();
    this.getMasterSocList();
    this.getCommonMessages();
    this.getCategoryForCase();
    this.getPetitioners();
    this.getvisaforNewCase();
    this.loginUserData = this.$store.state.user; // this.checkProperty(this.$store,'state','user');
    this.loginRoleId = this.$store.state.user.roleId; //this.checkProperty(this.$store['state'],'user','roleId');
    this.sortKey = {
      path: "lastName", // invitedByName, updatedOn, name, email, phone, statusName, roleName
      order: 1,
    };

    this.sortKeys = {
      invitedByName: 1,
      updatedOn: 1,
      name: 1,
      email: 1,
      phone: 1,
      statusName: 1,
      createdOn: -1,
      roleName: 1,
      hiredOn:1,
      terminatedOn:1,
      middleName:1,
      statusId:1,
      lastName:1,
      firstName:1

    };
    let postData = {
      matcher: {},
      page: 1,
      perpage: 1000,
      category: "countries",
    };
    this.getBranchList();
    this.$store.dispatch("getMasterData", postData).then((response) => {
      this.all_countries = response.list;
    });

    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];

    this.seleted_locations = [];
    this.final_selected_locations = [];
    this.get_statusids();

    this.getvisatypes();
    this.getvisasubtypes();
    this.filterQueryPreSelect();
    //this.getbeneficiaries();

  },
  computed: {
    showDropdownIcon() {},
  },
};
</script>